/* 
 * Package: xrefs.js
 * 
 * Namespace: amigo.data.xrefs
 * 
 * This package was automatically created during an AmiGO 2 installation
 * from the GO.xrf_abbs file at: "https://raw.githubusercontent.com/geneontology/go-site/master/metadata/db-xrefs.yaml".
 *
 * NOTE: This file is generated dynamically at installation time.
 * Hard to work with unit tests--hope it's not too bad. You have to
 * occasionally copy back to keep the unit tests sane.
 */

/*
 * Variable: xrefs
 * 
 * All the external references that we know about.
 */
var xrefs = {
   "syscilia_ccnet" : {
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "SYSCILIA_CCNET",
      "generic_url" : "http://syscilia.org/",
      "fullname" : "A systems biology approach to dissect cilia function and its disruption in human genetic disease",
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "Syscilia",
      "object" : "entity",
      "url_example" : null,
      "id" : "SYSCILIA_CCNET",
      "name" : "Syscilia"
   },
   "ensemblprotists" : {
      "name" : "Ensembl Protists, the Ensembl database for accessing genome-scale data from protists.",
      "url_example" : "http://www.ensemblgenomes.org/id/PFL2550w",
      "object" : "gene",
      "id" : "EnsemblProtists",
      "database" : "Ensembl Protists, the Ensembl database for accessing genome-scale data from protists.",
      "generic_url" : "http://protists.ensembl.org/",
      "datatype" : "gene",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.ensemblgenomes.org/id/[example_id]",
      "abbreviation" : "EnsemblProtists",
      "example_id" : "EnsemblProtists:PFL2550w"
   },
   "phenoscape" : {
      "database" : "PhenoScape Knowledgebase",
      "id" : "PhenoScape",
      "url_example" : null,
      "object" : "entity",
      "name" : "PhenoScape Knowledgebase",
      "example_id" : null,
      "abbreviation" : "PhenoScape",
      "url_syntax" : null,
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://phenoscape.org/",
      "fullname" : null
   },
   "biomdid" : {
      "name" : "BioModels Database",
      "id" : "BIOMD",
      "url_example" : "http://www.ebi.ac.uk/compneur-srv/biomodels-main/publ-model.do?mid=BIOMD0000000045",
      "object" : "entity",
      "database" : "BioModels Database",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.ebi.ac.uk/biomodels/",
      "datatype" : "entity",
      "abbreviation" : "BIOMDID",
      "example_id" : "BIOMD:BIOMD0000000045",
      "url_syntax" : "http://www.ebi.ac.uk/compneur-srv/biomodels-main/publ-model.do?mid=[example_id]"
   },
   "jcvi_medtr" : {
      "url_example" : "http://medicago.jcvi.org/cgi-bin/medicago/search/shared/ORF_infopage.cgi?orf=Medtr5g024510",
      "object" : "entity",
      "id" : "JCVI_Medtr",
      "name" : "Medicago truncatula genome database at the J. Craig Venter Institute",
      "database" : "Medicago truncatula genome database at the J. Craig Venter Institute",
      "url_syntax" : "http://medicago.jcvi.org/cgi-bin/medicago/search/shared/ORF_infopage.cgi?orf=[example_id]",
      "example_id" : "JCVI_Medtr:Medtr5g024510",
      "abbreviation" : "JCVI_Medtr",
      "datatype" : "entity",
      "generic_url" : "http://medicago.jcvi.org/cgi-bin/medicago/overview.cgi",
      "fullname" : null,
      "uri_prefix" : null
   },
   "ipr" : {
      "database" : "InterPro database of protein domains and motifs",
      "url_example" : "http://www.ebi.ac.uk/interpro/entry/IPR015421",
      "object" : "polypeptide region",
      "id" : "InterPro",
      "name" : "InterPro database of protein domains and motifs",
      "url_syntax" : "http://www.ebi.ac.uk/interpro/entry/[example_id]",
      "abbreviation" : "IPR",
      "example_id" : "InterPro:IPR000001",
      "datatype" : "polypeptide region",
      "generic_url" : "http://www.ebi.ac.uk/interpro/",
      "fullname" : null,
      "uri_prefix" : null
   },
   "echobase" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.ecoli-york.org/",
      "datatype" : "gene",
      "abbreviation" : "EchoBASE",
      "example_id" : "EchoBASE:EB0231",
      "url_syntax" : "http://www.biolws1.york.ac.uk/echobase/Gene.cfm?recordID=[example_id]",
      "name" : "EchoBASE post-genomic database for Escherichia coli",
      "id" : "EchoBASE",
      "url_example" : "http://www.biolws1.york.ac.uk/echobase/Gene.cfm?recordID=EB0231",
      "object" : "gene",
      "database" : "EchoBASE post-genomic database for Escherichia coli"
   },
   "casgen" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://research.calacademy.org/research/ichthyology/catalog/fishcatsearch.html",
      "datatype" : "entity",
      "example_id" : "CASGEN:1040",
      "abbreviation" : "CASGEN",
      "url_syntax" : "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Genus&id=[example_id]",
      "database" : "Catalog of Fishes genus database",
      "name" : "Catalog of Fishes genus database",
      "id" : "CASGEN",
      "object" : "entity",
      "url_example" : "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Genus&id=1040"
   },
   "pato" : {
      "name" : "Phenotypic quality ontology",
      "id" : "PATO",
      "url_example" : null,
      "object" : "entity",
      "database" : "Phenotypic quality ontology",
      "uri_prefix" : null,
      "generic_url" : "http://www.bioontology.org/wiki/index.php/PATO:Main_Page",
      "datatype" : "entity",
      "fullname" : null,
      "abbreviation" : "PATO",
      "example_id" : "PATO:0001420",
      "url_syntax" : null
   },
   "ensemblfungi" : {
      "datatype" : "gene",
      "generic_url" : "http://fungi.ensembl.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.ensemblgenomes.org/id/[example_id]",
      "example_id" : "EnsemblFungi:YOR197W",
      "abbreviation" : "EnsemblFungi",
      "database" : "Ensembl Fungi, the Ensembl database for accessing genome-scale data from fungi.",
      "name" : "Ensembl Fungi, the Ensembl database for accessing genome-scale data from fungi.",
      "url_example" : "http://www.ensemblgenomes.org/id/YOR197W",
      "object" : "gene",
      "id" : "EnsemblFungi"
   },
   "maizegdb_locus" : {
      "generic_url" : "http://www.maizegdb.org",
      "datatype" : "gene",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.maizegdb.org/cgi-bin/displaylocusresults.cgi?term=[example_id]",
      "abbreviation" : "MaizeGDB_Locus",
      "example_id" : "MaizeGDB_Locus:ZmPK1",
      "name" : "MaizeGDB",
      "url_example" : "http://www.maizegdb.org/cgi-bin/displaylocusresults.cgi?term=ZmPK1",
      "object" : "gene",
      "id" : "MaizeGDB_Locus",
      "database" : "MaizeGDB"
   },
   "ecocyc" : {
      "example_id" : "EcoCyc:P2-PWY",
      "abbreviation" : "EcoCyc",
      "url_syntax" : "http://biocyc.org/ECOLI/NEW-IMAGE?type=PATHWAY&object=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://ecocyc.org/",
      "datatype" : "biological_process",
      "fullname" : null,
      "id" : "EcoCyc",
      "object" : "biological_process",
      "url_example" : "http://biocyc.org/ECOLI/NEW-IMAGE?type=PATHWAY&object=P2-PWY",
      "name" : "Encyclopedia of E. coli metabolism",
      "database" : "Encyclopedia of E. coli metabolism"
   },
   "nasc" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://arabidopsis.info",
      "datatype" : "entity",
      "abbreviation" : "NASC",
      "example_id" : "NASC_code:N3371",
      "url_syntax" : "http://seeds.nottingham.ac.uk/NASC/stockatidb.lasso?code=[example_id]",
      "database" : "Nottingham Arabidopsis Stock Centre Seeds Database",
      "name" : "Nottingham Arabidopsis Stock Centre Seeds Database",
      "id" : "NASC_code",
      "url_example" : "http://seeds.nottingham.ac.uk/NASC/stockatidb.lasso?code=N3371",
      "object" : "entity"
   },
   "psi-mi" : {
      "uri_prefix" : null,
      "generic_url" : "http://psidev.sourceforge.net/mi/xml/doc/user/index.html",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "MI:0018",
      "abbreviation" : "PSI-MI",
      "url_syntax" : null,
      "database" : "Proteomic Standard Initiative for Molecular Interaction",
      "name" : "Proteomic Standard Initiative for Molecular Interaction",
      "id" : "PSI-MI",
      "url_example" : null,
      "object" : "entity"
   },
   "germonline" : {
      "url_syntax" : null,
      "abbreviation" : "GermOnline",
      "example_id" : null,
      "generic_url" : "http://www.germonline.org/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "GermOnline",
      "object" : "entity",
      "url_example" : null,
      "id" : "GermOnline",
      "name" : "GermOnline"
   },
   "mgcsc_genetic_stocks" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.maizegdb.org",
      "datatype" : "entity",
      "fullname" : null,
      "example_id" : "MGCSC_GENETIC_STOCKS:78112",
      "abbreviation" : "MGCSC_GENETIC_STOCKS",
      "url_syntax" : "http://www.maizegdb.org/cgi-bin/displaystockrecord.cgi?id=[example_id]",
      "name" : "Maize Genetics and Genomics Database",
      "id" : "MGCSC_GENETIC_STOCKS",
      "url_example" : "http://www.maizegdb.org/cgi-bin/displaytraitrecord.cgi?id=78112",
      "object" : "entity",
      "database" : "Maize Genetics and Genomics Database"
   },
   "aspgd" : {
      "name" : "Aspergillus Genome Database",
      "url_example" : "http://www.aspergillusgenome.org/cgi-bin/locus.pl?dbid=ASPL0000067538",
      "object" : "gene",
      "id" : "AspGD",
      "database" : "Aspergillus Genome Database",
      "datatype" : "gene",
      "generic_url" : "http://www.aspergillusgenome.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.aspergillusgenome.org/cgi-bin/locus.pl?dbid=[example_id]",
      "abbreviation" : "ASPGD",
      "example_id" : "AspGD:ASPL0000067538"
   },
   "imgt_ligm" : {
      "generic_url" : "http://imgt.cines.fr",
      "fullname" : "Database of immunoglobulins and T cell receptors from human and other vertebrates, with translation for fully annotated sequences.",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "abbreviation" : "IMGT_LIGM",
      "example_id" : "IMGT_LIGM:U03895",
      "name" : "ImMunoGeneTics database covering immunoglobulins and T-cell receptors",
      "url_example" : null,
      "object" : "entity",
      "id" : "IMGT_LIGM",
      "database" : "ImMunoGeneTics database covering immunoglobulins and T-cell receptors"
   },
   "aspgd_ref" : {
      "database" : "Aspergillus Genome Database",
      "id" : "AspGD_REF",
      "url_example" : "http://www.aspergillusgenome.org/cgi-bin/reference/reference.pl?dbid=90",
      "object" : "entity",
      "name" : "Aspergillus Genome Database",
      "abbreviation" : "AspGD_REF",
      "example_id" : "AspGD_REF:90",
      "url_syntax" : "http://www.aspergillusgenome.org/cgi-bin/reference/reference.pl?dbid=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.aspergillusgenome.org/",
      "fullname" : null,
      "datatype" : "entity"
   },
   "wb_ref" : {
      "url_syntax" : "http://www.wormbase.org/db/misc/paper?name=[example_id]",
      "example_id" : "WB_REF:WBPaper00004823",
      "abbreviation" : "WB_REF",
      "generic_url" : "http://www.wormbase.org/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "WormBase database of nematode biology",
      "url_example" : "http://www.wormbase.org/db/misc/paper?name=WBPaper00004823",
      "object" : "entity",
      "id" : "WB_REF",
      "name" : "WormBase database of nematode biology"
   },
   "nasc_code" : {
      "abbreviation" : "NASC_code",
      "example_id" : "NASC_code:N3371",
      "url_syntax" : "http://seeds.nottingham.ac.uk/NASC/stockatidb.lasso?code=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://arabidopsis.info",
      "fullname" : null,
      "datatype" : "entity",
      "database" : "Nottingham Arabidopsis Stock Centre Seeds Database",
      "id" : "NASC_code",
      "object" : "entity",
      "url_example" : "http://seeds.nottingham.ac.uk/NASC/stockatidb.lasso?code=N3371",
      "name" : "Nottingham Arabidopsis Stock Centre Seeds Database"
   },
   "cdd" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=cdd",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "CDD:34222",
      "abbreviation" : "CDD",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/Structure/cdd/cddsrv.cgi?uid=[example_id]",
      "name" : "Conserved Domain Database at NCBI",
      "id" : "CDD",
      "url_example" : "http://www.ncbi.nlm.nih.gov/Structure/cdd/cddsrv.cgi?uid=34222",
      "object" : "entity",
      "database" : "Conserved Domain Database at NCBI"
   },
   "irri" : {
      "database" : "IRRI Genetic Resources Information Management System",
      "id" : "GRIMS",
      "url_example" : "https://www.genesys-pgr.org/acn/search2?q=IRGC+90637",
      "object" : "germplasm",
      "name" : "IRRI Genetic Resources Information Management System",
      "abbreviation" : "irri",
      "example_id" : "GRIMS:90637",
      "url_syntax" : "https://www.genesys-pgr.org/acn/search2?q=IRGC+[example_id]",
      "uri_prefix" : null,
      "generic_url" : "https://www.genesys-pgr.org",
      "datatype" : "germplasm",
      "fullname" : null
   },
   "po_git" : {
      "database" : "GitHub Issue Tracker for PO",
      "name" : "GitHub Issue Tracker for PO",
      "id" : "PO_GIT",
      "url_example" : "https://github.com/Planteome/plant-ontology/issues/626",
      "object" : "entity",
      "uri_prefix" : null,
      "generic_url" : "https://github.com/Planteome/plant-ontology",
      "datatype" : "entity",
      "fullname" : null,
      "example_id" : "PO_GIT:626",
      "abbreviation" : "PO_GIT",
      "url_syntax" : "https://github.com/Planteome/plant-ontology/issues/[example_id]"
   },
   "jcvi_ref" : {
      "generic_url" : "http://cmr.jcvi.org/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : "JCVI_REF:GO_ref",
      "abbreviation" : "JCVI_REF",
      "name" : "J. Craig Venter Institute",
      "object" : "entity",
      "url_example" : "http://cmr.jcvi.org/CMR/AnnotationSops.shtml",
      "id" : "JCVI_REF",
      "database" : "J. Craig Venter Institute"
   },
   "cafa" : {
      "uri_prefix" : null,
      "generic_url" : "http://biofunctionprediction.org/cafa/",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : null,
      "abbreviation" : "CAFA",
      "url_syntax" : null,
      "database" : "Critical Assessment of Protein Function Annotation",
      "name" : "Critical Assessment of Protein Function Annotation",
      "id" : "CAFA",
      "url_example" : null,
      "object" : "entity"
   },
   "uniprotkb-subcell" : {
      "database" : "UniProt Knowledgebase Subcellular Location vocabulary",
      "name" : "UniProt Knowledgebase Subcellular Location vocabulary",
      "id" : "UniProtKB-SubCell",
      "object" : "entity",
      "url_example" : "http://www.uniprot.org/locations/SL-0012",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.uniprot.org/locations/",
      "datatype" : "entity",
      "example_id" : "UniProtKB-SubCell:SL-0012",
      "abbreviation" : "UniProtKB-SubCell",
      "url_syntax" : "http://www.uniprot.org/locations/[example_id]"
   },
   "maizegdb_ref" : {
      "database" : "Maize Genetics and Genomics Database",
      "name" : "Maize Genetics and Genomics Database",
      "id" : "MaizeGDB_REF",
      "object" : "entity",
      "url_example" : "http://maizegdb.org/data_center/reference?id=9021423",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.maizegdb.org/",
      "fullname" : null,
      "abbreviation" : "MaizeGDB_REF",
      "example_id" : "MaizeGDB_REF:9021423",
      "url_syntax" : "http://maizegdb.org/data_center/reference?id=[example_id]"
   },
   "swiss-prot" : {
      "database" : "Swiss-Prot protein database.",
      "url_example" : "http://www.ebi.uniprot.org/uniprot-srv/uniProtView.do?proteinac=P45867",
      "object" : "entity",
      "id" : "Swiss-Prot",
      "name" : "Swiss-Prot protein database.",
      "url_syntax" : "http://www.ebi.uniprot.org/uniprot-srv/uniProtView.do?proteinac=[example_id]",
      "abbreviation" : "Swiss-Prot",
      "example_id" : "Swiss-Prot:P45867",
      "fullname" : null,
      "generic_url" : "http://ca.expasy.org/sprot/",
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "apsnet" : {
      "object" : "entity",
      "url_example" : "http://www.apsnet.org/publications/commonnames/Pages/AfricanDaisy.aspx",
      "id" : "APSNET",
      "name" : "APSNET Common Names of Plant Diseases",
      "database" : "APSNET Common Names of Plant Diseases",
      "url_syntax" : "http://www.apsnet.org/publications/commonnames/Pages/[example_id].aspx",
      "abbreviation" : "APSNET",
      "example_id" : "APSNET:AfricanDaisy",
      "fullname" : null,
      "generic_url" : "http://www.mobot.org/mobot/research/apweb/",
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "aracyc" : {
      "id" : "AraCyc",
      "object" : "entity",
      "url_example" : "http://www.arabidopsis.org:1555/ARA/NEW-IMAGE?type=NIL&object=PWYQT-62",
      "name" : "AraCyc metabolic pathway database for Arabidopsis thaliana",
      "database" : "AraCyc metabolic pathway database for Arabidopsis thaliana",
      "abbreviation" : "AraCyc",
      "example_id" : "AraCyc:PWYQT-62",
      "url_syntax" : "http://www.arabidopsis.org:1555/ARA/NEW-IMAGE?type=NIL&object=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.arabidopsis.org/biocyc/index.jsp",
      "fullname" : null,
      "datatype" : "entity"
   },
   "gdb" : {
      "object" : "entity",
      "url_example" : "http://www.gdb.org/gdb-bin/genera/accno?accessionNum=GDB:306600",
      "id" : "GDB",
      "name" : "Human Genome Database",
      "database" : "Human Genome Database",
      "url_syntax" : "http://www.gdb.org/gdb-bin/genera/accno?accessionNum=GDB:[example_id]",
      "abbreviation" : "GDB",
      "example_id" : "GDB:306600",
      "generic_url" : "http://www.gdb.org/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null
   },
   "sp_sl" : {
      "datatype" : "entity",
      "generic_url" : "http://www.uniprot.org/locations/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.uniprot.org/locations/[example_id]",
      "example_id" : "UniProtKB-SubCell:SL-0012",
      "abbreviation" : "SP_SL",
      "database" : "UniProt Knowledgebase Subcellular Location vocabulary",
      "name" : "UniProt Knowledgebase Subcellular Location vocabulary",
      "object" : "entity",
      "url_example" : "http://www.uniprot.org/locations/SL-0012",
      "id" : "UniProtKB-SubCell"
   },
   "eco" : {
      "example_id" : "ECO:0000002",
      "abbreviation" : "ECO",
      "url_syntax" : null,
      "uri_prefix" : null,
      "generic_url" : "http://www.geneontology.org/",
      "fullname" : null,
      "datatype" : "entity",
      "id" : "ECO",
      "object" : "entity",
      "url_example" : null,
      "name" : "Evidence Code ontology",
      "database" : "Evidence Code ontology"
   },
   "omim" : {
      "url_syntax" : "http://omim.org/entry/[example_id]",
      "example_id" : "OMIM:190198",
      "abbreviation" : "OMIM",
      "fullname" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=OMIM",
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "Mendelian Inheritance in Man",
      "url_example" : "http://omim.org/entry/190198",
      "object" : "entity",
      "id" : "OMIM",
      "name" : "Mendelian Inheritance in Man"
   },
   "soy_ref" : {
      "fullname" : null,
      "generic_url" : "http://soybase.org/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://www.soybase.org/sbt/search/search_results.php?category=Soybase_ID&search_term=[example_id]",
      "example_id" : "SOY ref:SoyBase6597900",
      "abbreviation" : "SOY_ref",
      "database" : "SoyBase",
      "name" : "SoyBase",
      "object" : "entity",
      "url_example" : "http://www.soybase.org/sbt/search/search_results.php?category=Soybase_ID&search_term=SoyBase3142000126",
      "id" : "SOY_ref"
   },
   "plantsystematics_image_archive" : {
      "database" : "PlantSystematics.org",
      "name" : "PlantSystematics.org",
      "url_example" : "http://www.plantsystematics.org/imagebyid_37658.html",
      "object" : "entity",
      "id" : "PlantSystematics_image_archive",
      "datatype" : "entity",
      "generic_url" : "http://plantsystematics.org",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.plantsystematics.org/imagebyid_[example_id].html",
      "example_id" : "PlantSystematics_image_archivee:37658",
      "abbreviation" : "PlantSystematics_image_archive"
   },
   "iptmnet" : {
      "database" : "iPTMnet protein post-translational modification database",
      "name" : "iPTMnet protein post-translational modification database",
      "id" : "iPTMnet",
      "url_example" : "http://annotation.dbi.udel.edu/iptmnet/entry/P06493/",
      "object" : "entity",
      "uri_prefix" : null,
      "generic_url" : "http://annotation.dbi.udel.edu/iptmnet/",
      "datatype" : "entity",
      "fullname" : null,
      "example_id" : "iPTM:P06493",
      "abbreviation" : "iPTMnet",
      "url_syntax" : "http://annotation.dbi.udel.edu/iptmnet/entry/[example_id]/"
   },
   "alzheimers_university_of_toronto" : {
      "name" : "Alzheimers Project at University of Toronto",
      "object" : "entity",
      "url_example" : null,
      "id" : "Alzheimers_University_of_Toronto",
      "database" : "Alzheimers Project at University of Toronto",
      "generic_url" : "http://www.ims.utoronto.ca/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : null,
      "abbreviation" : "Alzheimers_University_of_Toronto",
      "example_id" : null
   },
   "treegenes" : {
      "example_id" : "TreeGenes:254",
      "abbreviation" : "TreeGenes",
      "url_syntax" : "http://dendrome.ucdavis.edu/treegenes/protein/view_protein.php?id=[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://dendrome.ucdavis.edu/treegenes/",
      "datatype" : "entity",
      "id" : "TreeGenes",
      "url_example" : "http://dendrome.ucdavis.edu/treegenes/protein/view_protein.php?id=254",
      "object" : "entity",
      "name" : "Forest Tree Genome Database",
      "database" : "Forest Tree Genome Database"
   },
   "hpa_antibody" : {
      "database" : "Human Protein Atlas antibody information",
      "name" : "Human Protein Atlas antibody information",
      "url_example" : "http://www.proteinatlas.org/antibody_info.php?antibody_id=HPA000237",
      "object" : "entity",
      "id" : "HPA_antibody",
      "generic_url" : "http://www.proteinatlas.org/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.proteinatlas.org/antibody_info.php?antibody_id=[example_id]",
      "example_id" : "HPA_antibody:HPA000237",
      "abbreviation" : "HPA_antibody"
   },
   "casspc" : {
      "url_syntax" : "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Species&id=[example_id]",
      "abbreviation" : "CASSPC",
      "example_id" : null,
      "fullname" : null,
      "generic_url" : "http://research.calacademy.org/research/ichthyology/catalog/fishcatsearch.html",
      "datatype" : "entity",
      "uri_prefix" : null,
      "object" : "entity",
      "url_example" : "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Species&id=1979",
      "id" : "CASSPC",
      "name" : "Catalog of Fishes species database",
      "database" : "Catalog of Fishes species database"
   },
   "wb" : {
      "fullname" : null,
      "generic_url" : "http://www.wormbase.org/",
      "datatype" : "protein",
      "uri_prefix" : null,
      "url_syntax" : "http://www.wormbase.org/db/gene/gene?name=[example_id]",
      "example_id" : "WB:WBGene00003001",
      "abbreviation" : "WB",
      "name" : "WormBase database of nematode biology",
      "url_example" : "http://www.wormbase.org/db/get?class=Gene;name=WBGene00003001",
      "object" : "protein",
      "id" : "WB",
      "database" : "WormBase database of nematode biology"
   },
   "obo_sf2_peco" : {
      "object" : "entity",
      "url_example" : "https://sourceforge.net/p/obo/plant-environment-ontology-eo/89/",
      "id" : "OBO_SF2_PECO",
      "name" : "Source Forge OBO plant-experimental-conditions-ontology (PECO) term request tracker",
      "database" : "Source Forge OBO plant-experimental-conditions-ontology (PECO) term request tracker",
      "url_syntax" : "https://sourceforge.net/p/obo/plant-environment-ontology-eo/[example_id]",
      "abbreviation" : "OBO_SF2_PECO",
      "example_id" : "OBO_SF2_PECO:89",
      "fullname" : null,
      "generic_url" : "https://sourceforge.net/p/obo/plant-environment-ontology-eo/",
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "ipi" : {
      "datatype" : "entity",
      "generic_url" : "http://www.ebi.ac.uk/IPI/IPIhelp.html",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : null,
      "abbreviation" : "IPI",
      "example_id" : "IPI:IPI00000005.1",
      "database" : "International Protein Index",
      "name" : "International Protein Index",
      "object" : "entity",
      "url_example" : null,
      "id" : "IPI"
   },
   "bfo" : {
      "example_id" : "BFO:0000066",
      "abbreviation" : "BFO",
      "url_syntax" : "http://purl.obolibrary.org/obo/BFO_[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://purl.obolibrary.org/obo/bfo",
      "fullname" : "An upper ontology used by Open Bio Ontologies (OBO) Foundry. BFO contains upper-level classes as well as core relations such as part_of (BFO_0000050)",
      "datatype" : "entity",
      "id" : "BFO",
      "object" : "entity",
      "url_example" : "http://purl.obolibrary.org/obo/BFO_0000066",
      "name" : "Basic Formal Ontology",
      "database" : "Basic Formal Ontology"
   },
   "unimod" : {
      "abbreviation" : "UniMod",
      "example_id" : "UniMod:1287",
      "url_syntax" : "http://www.unimod.org/modifications_view.php?editid1=[example_id]",
      "uri_prefix" : null,
      "fullname" : "protein modifications for mass spectrometry",
      "generic_url" : "http://www.unimod.org/",
      "datatype" : "entity",
      "database" : "UniMod",
      "id" : "UniMod",
      "object" : "entity",
      "url_example" : "http://www.unimod.org/modifications_view.php?editid1=1287",
      "name" : "UniMod"
   },
   "ri" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.roslin.ac.uk/",
      "datatype" : "entity",
      "abbreviation" : "RI",
      "example_id" : null,
      "url_syntax" : null,
      "name" : "Roslin Institute",
      "id" : "Roslin_Institute",
      "url_example" : null,
      "object" : "entity",
      "database" : "Roslin Institute"
   },
   "pamgo" : {
      "generic_url" : "http://pamgo.vbi.vt.edu/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "abbreviation" : "PAMGO",
      "example_id" : null,
      "name" : "Plant-Associated Microbe Gene Ontology Interest Group",
      "url_example" : null,
      "object" : "entity",
      "id" : "PAMGO",
      "database" : "Plant-Associated Microbe Gene Ontology Interest Group"
   },
   "sgn_germplasm" : {
      "abbreviation" : "SGN_germplasm",
      "example_id" : "SGN_germplasm:6583",
      "url_syntax" : "http://solgenomics.net/stock/[example_id]/view/",
      "uri_prefix" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/PubMed/",
      "datatype" : "entity",
      "fullname" : null,
      "database" : "Sol Genomics Network",
      "id" : "SGN_germplasm",
      "url_example" : "http://solgenomics.net/stock/6583/view/",
      "object" : "entity",
      "name" : "Sol Genomics Network"
   },
   "pir" : {
      "name" : "Protein Information Resource",
      "url_example" : "http://pir.georgetown.edu/cgi-bin/pirwww/nbrfget?uid=I49499",
      "object" : "protein",
      "id" : "PIR",
      "database" : "Protein Information Resource",
      "generic_url" : "http://pir.georgetown.edu/",
      "fullname" : null,
      "datatype" : "protein",
      "uri_prefix" : null,
      "url_syntax" : "http://pir.georgetown.edu/cgi-bin/pirwww/nbrfget?uid=[example_id]",
      "example_id" : "PIR:I49499",
      "abbreviation" : "PIR"
   },
   "mtbbase" : {
      "url_example" : null,
      "object" : "entity",
      "id" : "MTBBASE",
      "name" : "Collection and Refinement of Physiological Data on Mycobacterium tuberculosis",
      "database" : "Collection and Refinement of Physiological Data on Mycobacterium tuberculosis",
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "MTBBASE",
      "generic_url" : "http://www.ark.in-berlin.de/Site/MTBbase.html",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null
   },
   "gr_gene" : {
      "id" : "GR_GENE",
      "url_example" : "http://www.gramene.org/db/genes/search_gene?acc=GR:0060198",
      "object" : "entity",
      "name" : "Gramene",
      "database" : "Gramene",
      "abbreviation" : "GR_gene",
      "example_id" : "GR_GENE:GR:0060198",
      "url_syntax" : "http://www.gramene.org/db/genes/search_gene?acc=[example_id]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.gramene.org/",
      "fullname" : null
   },
   "soy_gene" : {
      "database" : "SoyBase",
      "id" : "Soy_gene",
      "object" : "gene",
      "url_example" : "http://www.soybase.org/sbt/search/search_results.php?category=FeatureName&search_term=Glyma18g02210",
      "name" : "SoyBase",
      "abbreviation" : "Soy_gene",
      "example_id" : "Glyma18g02210",
      "url_syntax" : "http://www.soybase.org/sbt/search/search_results.php?category=FeatureName&search_term=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://soybase.org/",
      "fullname" : null,
      "datatype" : "gene"
   },
   "maizegdb_qtl" : {
      "generic_url" : "http://www.maizegdb.org/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.maizegdb.org/data_center/trait?id=[example_id]",
      "abbreviation" : "MaizeGDB_QTL",
      "example_id" : "MaizeGDB_QTL:78112",
      "database" : "Maize Genetics and Genomics Database",
      "name" : "Maize Genetics and Genomics Database",
      "url_example" : "http://www.maizegdb.org/data_center/trait?id=78112",
      "object" : "entity",
      "id" : "MaizeGDB_QTL"
   },
   "pamgo_vmd" : {
      "name" : "Virginia Bioinformatics Institute Microbial Database",
      "id" : "PAMGO_VMD",
      "object" : "entity",
      "url_example" : "http://vmd.vbi.vt.edu/cgi-bin/browse/go_detail.cgi?gene_id=109198",
      "database" : "Virginia Bioinformatics Institute Microbial Database",
      "uri_prefix" : null,
      "generic_url" : "http://phytophthora.vbi.vt.edu",
      "datatype" : "entity",
      "fullname" : "Virginia Bioinformatics Institute Microbial Database; member of PAMGO Interest Group",
      "abbreviation" : "PAMGO_VMD",
      "example_id" : "PAMGO_VMD:109198",
      "url_syntax" : "http://vmd.vbi.vt.edu/cgi-bin/browse/go_detail.cgi?gene_id=[example_id]"
   },
   "isrr" : {
      "abbreviation" : "ISRR",
      "example_id" : "ISRR:Richard Zobel",
      "url_syntax" : "http://wiki.plantontology.org/index.php/ISRR_references",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.rootresearch.org/",
      "fullname" : null,
      "database" : "International Society for Root Research",
      "id" : "ISRR",
      "object" : "entity",
      "url_example" : "http://wiki.plantontology.org/index.php/ISRR_references",
      "name" : "International Society for Root Research"
   },
   "mitre" : {
      "name" : "The MITRE Corporation",
      "object" : "entity",
      "url_example" : null,
      "id" : "MITRE",
      "database" : "The MITRE Corporation",
      "generic_url" : "http://www.mitre.org/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "MITRE"
   },
   "fbbt" : {
      "name" : "Drosophila gross anatomy",
      "id" : "FBbt",
      "object" : "entity",
      "url_example" : "http://flybase.org/cgi-bin/fbcvq.html?query=FBbt:00005177",
      "database" : "Drosophila gross anatomy",
      "uri_prefix" : null,
      "generic_url" : "http://flybase.org/",
      "datatype" : "entity",
      "fullname" : null,
      "abbreviation" : "FBbt",
      "example_id" : "FBbt:00005177",
      "url_syntax" : "http://flybase.org/cgi-bin/fbcvq.html?query=FBbt:[example_id]"
   },
   "rap-db" : {
      "url_syntax" : "http://rapdb.dna.affrc.go.jp/tools/search/run?id=on&attr=desc&attr=cgs&attr=cgn&attr=cgss&attr=cgns&attr=rgss&attr=rgns&keyword=[example_id]",
      "abbreviation" : "RAP-DB",
      "example_id" : "RAP-DB:OS01T0100600-01",
      "generic_url" : "http://rapdb.dna.affrc.go.jp",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "database" : "Rice annotation Project database",
      "object" : "entity",
      "url_example" : "http://rapdb.dna.affrc.go.jp/tools/search/run?id=on&attr=desc&attr=cgs&attr=cgn&attr=cgss&attr=cgns&attr=rgss&attr=rgns&keyword=Os01g0100200",
      "id" : "RAP-DB",
      "name" : "Rice annotation Project database"
   },
   "tigr_ref" : {
      "database" : "J. Craig Venter Institute",
      "url_example" : "http://cmr.jcvi.org/CMR/AnnotationSops.shtml",
      "object" : "entity",
      "id" : "JCVI_REF",
      "name" : "J. Craig Venter Institute",
      "url_syntax" : null,
      "abbreviation" : "TIGR_REF",
      "example_id" : "JCVI_REF:GO_ref",
      "generic_url" : "http://cmr.jcvi.org/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null
   },
   "sptrembl" : {
      "name" : "TREMBL",
      "id" : "TR",
      "object" : "entity",
      "url_example" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:Q00177]",
      "database" : "TREMBL",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.ebi.ac.uk/swissprot/",
      "fullname" : null,
      "example_id" : "TrEMBL:Q00177",
      "abbreviation" : "SPTREMBL",
      "url_syntax" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:[example_id]]"
   },
   "sgn_ref" : {
      "generic_url" : "http://www.sgn.cornell.edu/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.sgn.cornell.edu/chado/publication.pl?pub_id=[example_id]",
      "abbreviation" : "SGN_ref",
      "example_id" : "SGN_ref:861",
      "database" : "Sol Genomics Network",
      "name" : "Sol Genomics Network",
      "object" : "entity",
      "url_example" : "http://www.sgn.cornell.edu/chado/publication.pl?pub_id=861",
      "id" : "SGN_ref"
   },
   "riceses" : {
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/PubMed/",
      "fullname" : null,
      "abbreviation" : "RiceSES",
      "example_id" : "RiceSES:bakanae-diseases-bak",
      "url_syntax" : "http://www.knowledgebank.irri.org/extension/crop-damage-diseases/[example_id].html",
      "name" : "Rice Knowledge Bank",
      "id" : "RiceSES",
      "object" : "entity",
      "url_example" : "http://www.knowledgebank.irri.org/extension/crop-damage-diseases/bakanae-diseases-bak.html",
      "database" : "Rice Knowledge Bank"
   },
   "gr" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.gramene.org/",
      "fullname" : null,
      "datatype" : "protein",
      "example_id" : "GR:sd1",
      "abbreviation" : "GR",
      "url_syntax" : "http://www.gramene.org/db/searches/browser?search_type=All&RGN=on&query=[example_id]",
      "name" : "Gramene",
      "id" : "GR",
      "object" : "protein",
      "url_example" : "http://www.gramene.org/db/searches/browser?search_type=All&RGN=on&query=sd1",
      "database" : "Gramene"
   },
   "rnacentral" : {
      "id" : "RNAcentral",
      "object" : "ribonucleic acid",
      "url_example" : "http://rnacentral.org/rna/URS000047C79B_9606",
      "name" : "RNAcentral",
      "database" : "RNAcentral",
      "abbreviation" : "RNAcentral",
      "example_id" : "RNAcentral:URS000047C79B_9606",
      "url_syntax" : "http://rnacentral.org/rna/[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://rnacentral.org",
      "datatype" : "ribonucleic acid",
      "fullname" : "An international database of ncRNA sequences"
   },
   "vz" : {
      "example_id" : "VZ:957",
      "abbreviation" : "VZ",
      "url_syntax" : "http://viralzone.expasy.org/all_by_protein/[example_id].html",
      "uri_prefix" : null,
      "generic_url" : "http://viralzone.expasy.org/",
      "fullname" : null,
      "datatype" : "entity",
      "database" : "ViralZone",
      "id" : "VZ",
      "object" : "entity",
      "url_example" : "http://viralzone.expasy.org/all_by_protein/957.html",
      "name" : "ViralZone"
   },
   "chebi" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.ebi.ac.uk/chebi/",
      "fullname" : null,
      "datatype" : "chemical entity",
      "abbreviation" : "ChEBI",
      "example_id" : "CHEBI:17234",
      "url_syntax" : "http://www.ebi.ac.uk/chebi/searchId.do?chebiId=CHEBI:[example_id]",
      "name" : "Chemical Entities of Biological Interest",
      "id" : "CHEBI",
      "url_example" : "http://www.ebi.ac.uk/chebi/searchId.do?chebiId=CHEBI:17234",
      "object" : "chemical entity",
      "database" : "Chemical Entities of Biological Interest"
   },
   "locusid" : {
      "uri_prefix" : null,
      "datatype" : "gene",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/",
      "fullname" : null,
      "abbreviation" : "LocusID",
      "example_id" : "NCBI_Gene:4771",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/gene/[example_id]",
      "name" : "NCBI Gene",
      "id" : "NCBIGene",
      "object" : "gene",
      "url_example" : "http://www.ncbi.nlm.nih.gov/gene/4771",
      "database" : "NCBI Gene"
   },
   "iuphar" : {
      "url_syntax" : null,
      "abbreviation" : "IUPHAR",
      "example_id" : null,
      "generic_url" : "http://www.iuphar.org/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_example" : null,
      "object" : "entity",
      "id" : "IUPHAR",
      "name" : "International Union of Pharmacology",
      "database" : "International Union of Pharmacology"
   },
   "pubchem_substance" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://pubchem.ncbi.nlm.nih.gov/",
      "datatype" : "chemical entity",
      "example_id" : "PubChem_Substance:4594",
      "abbreviation" : "PubChem_Substance",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?CMD=search&DB=pcsubstance&term=[example_id]",
      "name" : "NCBI PubChem database of chemical substances",
      "id" : "PubChem_Substance",
      "url_example" : "http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?CMD=search&DB=pcsubstance&term=4594",
      "object" : "chemical entity",
      "database" : "NCBI PubChem database of chemical substances"
   },
   "mgd" : {
      "abbreviation" : "MGD",
      "example_id" : "MGD:Adcy9",
      "url_syntax" : null,
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.informatics.jax.org/",
      "datatype" : "entity",
      "database" : "Mouse Genome Database",
      "id" : "MGD",
      "url_example" : null,
      "object" : "entity",
      "name" : "Mouse Genome Database"
   },
   "modbase" : {
      "abbreviation" : "ModBase",
      "example_id" : "ModBase:P10815",
      "url_syntax" : "http://salilab.org/modbase/searchbyid?databaseID=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://modbase.compbio.ucsf.edu/",
      "fullname" : null,
      "datatype" : "entity",
      "id" : "ModBase",
      "url_example" : "http://salilab.org/modbase/searchbyid?databaseID=P04848",
      "object" : "entity",
      "name" : "ModBase comprehensive Database of Comparative Protein Structure Models",
      "database" : "ModBase comprehensive Database of Comparative Protein Structure Models"
   },
   "pro" : {
      "uri_prefix" : null,
      "datatype" : "protein",
      "generic_url" : "http://www.proconsortium.org/pro/pro.shtml",
      "fullname" : null,
      "abbreviation" : "PRO",
      "example_id" : "PR:000025380",
      "url_syntax" : "http://purl.obolibrary.org/obo/PR_[example_id]",
      "database" : "Protein Ontology",
      "name" : "Protein Ontology",
      "id" : "PR",
      "object" : "protein",
      "url_example" : "http://purl.obolibrary.org/obo/PR_000025380"
   },
   "sp_kw" : {
      "example_id" : "UniProtKB-KW:KW-0812",
      "abbreviation" : "SP_KW",
      "url_syntax" : "http://www.uniprot.org/keywords/[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.uniprot.org/keywords/",
      "datatype" : "entity",
      "fullname" : null,
      "database" : "UniProt Knowledgebase keywords",
      "id" : "UniProtKB-KW",
      "object" : "entity",
      "url_example" : "http://www.uniprot.org/keywords/KW-0812",
      "name" : "UniProt Knowledgebase keywords"
   },
   "broad" : {
      "url_syntax" : null,
      "abbreviation" : "Broad",
      "example_id" : null,
      "fullname" : null,
      "generic_url" : "http://www.broad.mit.edu/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_example" : null,
      "object" : "entity",
      "id" : "Broad",
      "name" : "Broad Institute",
      "database" : "Broad Institute"
   },
   "um-bbd_ruleid" : {
      "generic_url" : "http://eawag-bbd.ethz.ch/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://eawag-bbd.ethz.ch/servlets/rule.jsp?rule=[example_id]",
      "example_id" : "UM-BBD_ruleID:bt0330",
      "abbreviation" : "UM-BBD_ruleID",
      "database" : "EAWAG Biocatalysis/Biodegradation Database",
      "name" : "EAWAG Biocatalysis/Biodegradation Database",
      "object" : "entity",
      "url_example" : "http://eawag-bbd.ethz.ch/servlets/rule.jsp?rule=bt0330",
      "id" : "UM-BBD_ruleID"
   },
   "so" : {
      "url_syntax" : "http://www.sequenceontology.org/browser/current_svn/term/SO:[example_id]",
      "abbreviation" : "SO",
      "example_id" : "SO:0000195",
      "datatype" : "sequence feature",
      "generic_url" : "http://sequenceontology.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "object" : "sequence feature",
      "url_example" : "http://www.sequenceontology.org/browser/current_svn/term/SO:0001850",
      "id" : "SO",
      "name" : "Sequence Ontology",
      "database" : "Sequence Ontology"
   },
   "to_git" : {
      "id" : "TO_GIT",
      "url_example" : "https://github.com/Planteome/plant-trait-ontology/issues/381",
      "object" : "entity",
      "name" : "GitHub Issue Tracker for TO",
      "database" : "GitHub Issue Tracker for TO",
      "abbreviation" : "TO_GIT",
      "example_id" : "TO_GIT:381",
      "url_syntax" : "https://github.com/Planteome/plant-trait-ontology/issues/[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "https://github.com/Planteome/plant-trait-ontology",
      "datatype" : "entity"
   },
   "rnamods" : {
      "id" : "RNAmods",
      "url_example" : "http://s59.cas.albany.edu/RNAmods/cgi-bin/rnashow.cgi?091",
      "object" : "entity",
      "name" : "RNA Modification Database",
      "database" : "RNA Modification Database",
      "example_id" : "RNAmods:037",
      "abbreviation" : "RNAmods",
      "url_syntax" : "http://s59.cas.albany.edu/RNAmods/cgi-bin/rnashow.cgi?[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://s59.cas.albany.edu/RNAmods/",
      "datatype" : "entity"
   },
   "sptr" : {
      "abbreviation" : "SPTR",
      "example_id" : "SPTR:12345",
      "url_syntax" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:[example_id]]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://srs.ebi.ac.uk",
      "fullname" : null,
      "id" : "SPTR",
      "object" : "entity",
      "url_example" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:12345]",
      "name" : "SRS database at EBI",
      "database" : "SRS database at EBI"
   },
   "casref" : {
      "abbreviation" : "CASREF",
      "example_id" : "CASREF:2031",
      "url_syntax" : "http://research.calacademy.org/research/ichthyology/catalog/getref.asp?id=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://research.calacademy.org/research/ichthyology/catalog/fishcatsearch.html",
      "datatype" : "entity",
      "fullname" : null,
      "id" : "CASREF",
      "object" : "entity",
      "url_example" : "http://research.calacademy.org/research/ichthyology/catalog/getref.asp?id=2031",
      "name" : "Catalog of Fishes publications database",
      "database" : "Catalog of Fishes publications database"
   },
   "isbn" : {
      "uri_prefix" : null,
      "generic_url" : "http://isbntools.com/",
      "datatype" : "entity",
      "fullname" : null,
      "example_id" : "ISBN:0781702534",
      "abbreviation" : "ISBN",
      "url_syntax" : "http://openisbn.com/search.php?q=[example_id]&isbn=1/",
      "name" : "International Standard Book Number",
      "id" : "ISBN",
      "object" : "entity",
      "url_example" : "http://openisbn.com/search.php?q=0781702534&isbn=1/",
      "database" : "International Standard Book Number"
   },
   "asap" : {
      "example_id" : "ASAP:ABE-0000008",
      "abbreviation" : "ASAP",
      "url_syntax" : "https://asap.ahabs.wisc.edu/annotation/php/feature_info.php?FeatureID=[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "https://asap.ahabs.wisc.edu/annotation/php/ASAP1.htm",
      "datatype" : "gene",
      "database" : "A Systematic Annotation Package for Community Analysis of Genomes",
      "id" : "ASAP",
      "url_example" : "https://asap.ahabs.wisc.edu/annotation/php/feature_info.php?FeatureID=ABE-0000008",
      "object" : "gene",
      "name" : "A Systematic Annotation Package for Community Analysis of Genomes"
   },
   "xenbase" : {
      "url_syntax" : "http://www.xenbase.org/common/xsearch.do?searchValue=[example_id]",
      "example_id" : "Xenbase:XB-LINE-1248",
      "abbreviation" : "Xenbase",
      "fullname" : null,
      "generic_url" : "http://www.xenbase.org/",
      "datatype" : "strain",
      "uri_prefix" : null,
      "database" : "Xenbase",
      "url_example" : "http://www.xenbase.org/common/xsearch.do?searchValue=XB-LINE-1248",
      "object" : "strain",
      "id" : "Xenbase",
      "name" : "Xenbase"
   },
   "nif_subcellular" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.neurolex.org/wiki",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "NIF_Subcellular:sao1186862860",
      "abbreviation" : "NIF_Subcellular",
      "url_syntax" : "http://www.neurolex.org/wiki/[example_id]",
      "database" : "Neuroscience Information Framework standard ontology, subcellular hierarchy",
      "name" : "Neuroscience Information Framework standard ontology, subcellular hierarchy",
      "id" : "NIF_Subcellular",
      "url_example" : "http://www.neurolex.org/wiki/sao1770195789",
      "object" : "entity"
   },
   "cas_spc" : {
      "database" : "Catalog of Fishes species database",
      "id" : "CASSPC",
      "object" : "entity",
      "url_example" : "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Species&id=1979",
      "name" : "Catalog of Fishes species database",
      "example_id" : null,
      "abbreviation" : "CAS_SPC",
      "url_syntax" : "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Species&id=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://research.calacademy.org/research/ichthyology/catalog/fishcatsearch.html",
      "datatype" : "entity",
      "fullname" : null
   },
   "pirsf" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://pir.georgetown.edu/pirsf/",
      "datatype" : "entity",
      "abbreviation" : "PIRSF",
      "example_id" : "PIRSF:SF002327",
      "url_syntax" : "http://pir.georgetown.edu/cgi-bin/ipcSF?id=[example_id]",
      "name" : "PIR Superfamily Classification System",
      "id" : "PIRSF",
      "url_example" : "http://pir.georgetown.edu/cgi-bin/ipcSF?id=SF002327",
      "object" : "entity",
      "database" : "PIR Superfamily Classification System"
   },
   "obo_rel" : {
      "database" : "OBO relation ontology",
      "name" : "OBO relation ontology",
      "object" : "entity",
      "url_example" : null,
      "id" : "OBO_REL",
      "generic_url" : "http://www.obofoundry.org/ro/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : "OBO_REL:part_of",
      "abbreviation" : "OBO_REL"
   },
   "pmcid" : {
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/sites/entrez?db=pmc&cmd=search&term=[example_id]",
      "example_id" : "PMCID:PMC201377",
      "abbreviation" : "PMCID",
      "fullname" : null,
      "generic_url" : "http://www.pubmedcentral.nih.gov/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "object" : "entity",
      "url_example" : "http://www.ncbi.nlm.nih.gov/sites/entrez?db=pmc&cmd=search&term=PMC201377",
      "id" : "PMCID",
      "name" : "Pubmed Central",
      "database" : "Pubmed Central"
   },
   "hamap" : {
      "name" : "High-quality Automated and Manual Annotation of microbial Proteomes",
      "id" : "HAMAP",
      "object" : "entity",
      "url_example" : "http://hamap.expasy.org/unirule/MF_00131",
      "database" : "High-quality Automated and Manual Annotation of microbial Proteomes",
      "uri_prefix" : null,
      "generic_url" : "http://hamap.expasy.org/",
      "fullname" : null,
      "datatype" : "entity",
      "abbreviation" : "HAMAP",
      "example_id" : "HAMAP:MF_00031",
      "url_syntax" : "http://hamap.expasy.org/unirule/[example_id]"
   },
   "vbrc" : {
      "name" : "Viral Bioinformatics Resource Center",
      "id" : "VBRC",
      "object" : "entity",
      "url_example" : "http://vbrc.org/query.asp?web_id=VBRC:F35742",
      "database" : "Viral Bioinformatics Resource Center",
      "uri_prefix" : null,
      "generic_url" : "http://vbrc.org",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "VBRC:F35742",
      "abbreviation" : "VBRC",
      "url_syntax" : "http://vbrc.org/query.asp?web_id=VBRC:[example_id]"
   },
   "fb" : {
      "generic_url" : "http://flybase.org/",
      "fullname" : null,
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_syntax" : "http://flybase.org/reports/[example_id].html",
      "abbreviation" : "FB",
      "example_id" : "FB:FBgn0000024",
      "database" : "FlyBase",
      "name" : "FlyBase",
      "object" : "gene",
      "url_example" : "http://flybase.org/reports/FBgn0000024.html",
      "id" : "FB"
   },
   "aspgdid" : {
      "generic_url" : "http://www.aspergillusgenome.org/",
      "datatype" : "gene",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.aspergillusgenome.org/cgi-bin/locus.pl?dbid=[example_id]",
      "example_id" : "AspGD:ASPL0000067538",
      "abbreviation" : "AspGDID",
      "name" : "Aspergillus Genome Database",
      "object" : "gene",
      "url_example" : "http://www.aspergillusgenome.org/cgi-bin/locus.pl?dbid=ASPL0000067538",
      "id" : "AspGD",
      "database" : "Aspergillus Genome Database"
   },
   "mim" : {
      "database" : "Mendelian Inheritance in Man",
      "name" : "Mendelian Inheritance in Man",
      "id" : "OMIM",
      "object" : "entity",
      "url_example" : "http://omim.org/entry/190198",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=OMIM",
      "fullname" : null,
      "abbreviation" : "MIM",
      "example_id" : "OMIM:190198",
      "url_syntax" : "http://omim.org/entry/[example_id]"
   },
   "reac" : {
      "name" : "Reactome - a curated knowledgebase of biological pathways",
      "object" : "entity",
      "url_example" : "http://www.reactome.org/content/detail/R-HSA-109582",
      "id" : "Reactome",
      "database" : "Reactome - a curated knowledgebase of biological pathways",
      "generic_url" : "http://www.reactome.org/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://www.reactome.org/content/detail/[example_id]",
      "abbreviation" : "REAC",
      "example_id" : "Reactome:R-HSA-109582"
   },
   "smart" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://smart.embl-heidelberg.de/",
      "datatype" : "polypeptide region",
      "abbreviation" : "SMART",
      "example_id" : "SMART:SM00005",
      "url_syntax" : "http://smart.embl-heidelberg.de/smart/do_annotation.pl?BLAST=DUMMY&DOMAIN=[example_id]",
      "name" : "Simple Modular Architecture Research Tool",
      "id" : "SMART",
      "object" : "polypeptide region",
      "url_example" : "http://smart.embl-heidelberg.de/smart/do_annotation.pl?BLAST=DUMMY&DOMAIN=SM00005",
      "database" : "Simple Modular Architecture Research Tool"
   },
   "interpro" : {
      "name" : "InterPro database of protein domains and motifs",
      "url_example" : "http://www.ebi.ac.uk/interpro/entry/IPR015421",
      "object" : "polypeptide region",
      "id" : "InterPro",
      "database" : "InterPro database of protein domains and motifs",
      "fullname" : null,
      "generic_url" : "http://www.ebi.ac.uk/interpro/",
      "datatype" : "polypeptide region",
      "uri_prefix" : null,
      "url_syntax" : "http://www.ebi.ac.uk/interpro/entry/[example_id]",
      "example_id" : "InterPro:IPR000001",
      "abbreviation" : "INTERPRO"
   },
   "cbs" : {
      "generic_url" : "http://www.cbs.dtu.dk/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : "CBS:TMHMM",
      "abbreviation" : "CBS",
      "database" : "Center for Biological Sequence Analysis",
      "name" : "Center for Biological Sequence Analysis",
      "object" : "entity",
      "url_example" : "http://www.cbs.dtu.dk/services/[example_id]/",
      "id" : "CBS"
   },
   "mengo" : {
      "database" : "Microbial ENergy processes Gene Ontology Project",
      "object" : "entity",
      "url_example" : null,
      "id" : "MENGO",
      "name" : "Microbial ENergy processes Gene Ontology Project",
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "MENGO",
      "datatype" : "entity",
      "generic_url" : "http://mengo.vbi.vt.edu/",
      "fullname" : null,
      "uri_prefix" : null
   },
   "collectf" : {
      "name" : "Database of transcription factor binding sites (TFBS) in the Bacteria domain",
      "id" : "CollecTF",
      "url_example" : null,
      "object" : "entity",
      "database" : "Database of transcription factor binding sites (TFBS) in the Bacteria domain",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.collectf.org/",
      "datatype" : "entity",
      "example_id" : null,
      "abbreviation" : "CollecTF",
      "url_syntax" : null
   },
   "pmid" : {
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/pubmed/[example_id]",
      "example_id" : "PMID:4208797",
      "abbreviation" : "PMID",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/PubMed/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_example" : "http://www.ncbi.nlm.nih.gov/pubmed/4208797",
      "object" : "entity",
      "id" : "PMID",
      "name" : "PubMed",
      "database" : "PubMed"
   },
   "reactome" : {
      "id" : "Reactome",
      "url_example" : "http://www.reactome.org/content/detail/R-HSA-109582",
      "object" : "entity",
      "name" : "Reactome - a curated knowledgebase of biological pathways",
      "database" : "Reactome - a curated knowledgebase of biological pathways",
      "example_id" : "Reactome:R-HSA-109582",
      "abbreviation" : "REACTOME",
      "url_syntax" : "http://www.reactome.org/content/detail/[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.reactome.org/",
      "datatype" : "entity"
   },
   "prow" : {
      "database" : "Protein Reviews on the Web",
      "name" : "Protein Reviews on the Web",
      "object" : "entity",
      "url_example" : null,
      "id" : "PROW",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/prow/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "PROW"
   },
   "mod" : {
      "name" : "Proteomics Standards Initiative protein modification ontology",
      "url_example" : "http://www.ebi.ac.uk/ontology-lookup/?termId=MOD:00219",
      "object" : "entity",
      "id" : "PSI-MOD",
      "database" : "Proteomics Standards Initiative protein modification ontology",
      "generic_url" : "http://psidev.sourceforge.net/mod/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.ebi.ac.uk/ontology-lookup/?termId=MOD:[example_id]",
      "abbreviation" : "MOD",
      "example_id" : "MOD:00219"
   },
   "trait" : {
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://muscle.cribi.unipd.it/",
      "fullname" : "an integrated database of transcripts expressed in human skeletal muscle",
      "example_id" : null,
      "abbreviation" : "TRAIT",
      "url_syntax" : null,
      "database" : "TRAnscript Integrated Table",
      "name" : "TRAnscript Integrated Table",
      "id" : "TRAIT",
      "url_example" : null,
      "object" : "entity"
   },
   "sgn" : {
      "generic_url" : "http://www.sgn.cornell.edu/",
      "fullname" : null,
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_syntax" : "http://www.sgn.cornell.edu/phenome/locus_display.pl?locus_id=[example_id]",
      "example_id" : "SGN_gene:7740",
      "abbreviation" : "SGN",
      "name" : "Sol Genomics Network",
      "url_example" : "http://solgenomics.net/phenome/locus_display.pl?locus_id=7740",
      "object" : "gene",
      "id" : "SGN",
      "database" : "Sol Genomics Network"
   },
   "cribi_vitis" : {
      "uri_prefix" : null,
      "generic_url" : "http://genomes.cribi.unipd.it",
      "datatype" : "entity",
      "fullname" : null,
      "example_id" : "VIT_00s0173g00270",
      "abbreviation" : "cribi_vitis",
      "url_syntax" : "http://genomes.cribi.unipd.it/cgi-bin/pqs2/report.pl?gene_name=[example_id]&release=v1",
      "name" : "Vitis CRIBI database",
      "id" : "cribi_vitis",
      "object" : "entity",
      "url_example" : "http://genomes.cribi.unipd.it/cgi-bin/pqs2/report.pl?gene_name=VIT_00s0173g00270&release=v1",
      "database" : "Vitis CRIBI database"
   },
   "cog_cluster" : {
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/COG/",
      "fullname" : null,
      "example_id" : "COG_Cluster:COG0001",
      "abbreviation" : "COG_Cluster",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/COG/new/release/cow.cgi?cog=[example_id]",
      "database" : "NCBI COG cluster",
      "name" : "NCBI COG cluster",
      "id" : "COG_Cluster",
      "url_example" : "http://www.ncbi.nlm.nih.gov/COG/new/release/cow.cgi?cog=COG0001",
      "object" : "entity"
   },
   "sgn_gene" : {
      "generic_url" : "http://www.sgn.cornell.edu/",
      "fullname" : null,
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_syntax" : "http://www.sgn.cornell.edu/phenome/locus_display.pl?locus_id=[example_id]",
      "abbreviation" : "SGN_gene",
      "example_id" : "SGN_gene:7740",
      "database" : "Sol Genomics Network",
      "name" : "Sol Genomics Network",
      "object" : "gene",
      "url_example" : "http://solgenomics.net/phenome/locus_display.pl?locus_id=7740",
      "id" : "SGN"
   },
   "aspgd_locus" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.aspergillusgenome.org/",
      "datatype" : "entity",
      "example_id" : "AspGD_LOCUS:AN10942",
      "abbreviation" : "AspGD_LOCUS",
      "url_syntax" : "http://www.aspergillusgenome.org/cgi-bin/locus.pl?locus=[example_id]",
      "name" : "Aspergillus Genome Database",
      "id" : "AspGD_LOCUS",
      "url_example" : "http://www.aspergillusgenome.org/cgi-bin/locus.pl?locus=AN10942",
      "object" : "entity",
      "database" : "Aspergillus Genome Database"
   },
   "ncbi_gp" : {
      "example_id" : "NCBI_GP:EAL72968",
      "abbreviation" : "NCBI_GP",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?db=protein&val=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/",
      "fullname" : null,
      "datatype" : "protein",
      "database" : "NCBI GenPept",
      "id" : "NCBI_GP",
      "url_example" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?db=protein&val=EAL72968",
      "object" : "protein",
      "name" : "NCBI GenPept"
   },
   "cl" : {
      "name" : "Cell Type Ontology",
      "id" : "CL",
      "url_example" : "http://purl.obolibrary.org/obo/CL_0000041",
      "object" : "cell",
      "database" : "Cell Type Ontology",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://cellontology.org",
      "datatype" : "cell",
      "example_id" : "CL:0000041",
      "abbreviation" : "CL",
      "url_syntax" : "http://purl.obolibrary.org/obo/CL_[example_id]"
   },
   "seed" : {
      "id" : "SEED",
      "object" : "entity",
      "url_example" : "http://www.theseed.org/linkin.cgi?id=fig|83331.1.peg.1",
      "name" : "The SEED;",
      "database" : "The SEED;",
      "abbreviation" : "SEED",
      "example_id" : "SEED:fig|83331.1.peg.1",
      "url_syntax" : "http://www.theseed.org/linkin.cgi?id=[example_id]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.theseed.org",
      "fullname" : "Project to annotate the first 1000 sequenced genomes, develop detailed metabolic reconstructions, and construct the corresponding stoichiometric matrices"
   },
   "uniprotkb-kw" : {
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.uniprot.org/keywords/",
      "fullname" : null,
      "abbreviation" : "UniProtKB-KW",
      "example_id" : "UniProtKB-KW:KW-0812",
      "url_syntax" : "http://www.uniprot.org/keywords/[example_id]",
      "name" : "UniProt Knowledgebase keywords",
      "id" : "UniProtKB-KW",
      "url_example" : "http://www.uniprot.org/keywords/KW-0812",
      "object" : "entity",
      "database" : "UniProt Knowledgebase keywords"
   },
   "pamgo_mgg" : {
      "object" : "entity",
      "url_example" : "http://scotland.fgl.ncsu.edu/cgi-bin/adHocQuery.cgi?adHocQuery_dbName=smeng_goannotation&Action=Data&QueryName=Functional+Categorization+of+MGG+GO+Annotation&P_KeyWord=MGG_05132",
      "id" : "PAMGO_MGG",
      "name" : "Magnaporthe grisea database",
      "database" : "Magnaporthe grisea database",
      "url_syntax" : "http://scotland.fgl.ncsu.edu/cgi-bin/adHocQuery.cgi?adHocQuery_dbName=smeng_goannotation&Action=Data&QueryName=Functional+Categorization+of+MGG+GO+Annotation&P_KeyWord=[example_id]",
      "example_id" : "PAMGO_MGG:MGG_05132",
      "abbreviation" : "PAMGO_MGG",
      "generic_url" : "http://scotland.fgl.ncsu.edu/smeng/GoAnnotationMagnaporthegrisea.html",
      "datatype" : "entity",
      "fullname" : "Magnaporthe grisea database at North Carolina State University; member of PAMGO Interest Group",
      "uri_prefix" : null
   },
   "protein_id" : {
      "name" : "DDBJ / ENA / GenBank",
      "url_example" : null,
      "object" : "protein",
      "id" : "protein_id",
      "database" : "DDBJ / ENA / GenBank",
      "fullname" : "protein identifier shared by DDBJ/EMBL-bank/GenBank nucleotide sequence databases",
      "generic_url" : "http://www.ddbj.nig.ac.jp/",
      "datatype" : "protein",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : "protein_id:CAA71991",
      "abbreviation" : "protein_id"
   },
   "go_central" : {
      "generic_url" : "http://www.geneontology.org/GO.refgenome.shtml",
      "fullname" : "Manual annotation from PAINT curators into the UniProt Protein2GO curation tool.",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "abbreviation" : "GO_CENTRAL",
      "example_id" : null,
      "name" : "GO Central",
      "url_example" : null,
      "object" : "entity",
      "id" : "GO_Central",
      "database" : "GO Central"
   },
   "wormbase" : {
      "name" : "WormBase database of nematode biology",
      "object" : "protein",
      "url_example" : "http://www.wormbase.org/db/get?class=Gene;name=WBGene00003001",
      "id" : "WB",
      "database" : "WormBase database of nematode biology",
      "fullname" : null,
      "generic_url" : "http://www.wormbase.org/",
      "datatype" : "protein",
      "uri_prefix" : null,
      "url_syntax" : "http://www.wormbase.org/db/gene/gene?name=[example_id]",
      "example_id" : "WB:WBGene00003001",
      "abbreviation" : "WormBase"
   },
   "ncbi" : {
      "generic_url" : "http://www.ncbi.nlm.nih.gov/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "NCBI",
      "database" : "National Center for Biotechnology Information",
      "name" : "National Center for Biotechnology Information",
      "object" : "entity",
      "url_example" : null,
      "id" : "NCBI"
   },
   "dflat" : {
      "abbreviation" : "DFLAT",
      "example_id" : null,
      "url_syntax" : null,
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://bcb.cs.tufts.edu/dflat/",
      "fullname" : null,
      "id" : "DFLAT",
      "url_example" : null,
      "object" : "entity",
      "name" : "Developmental FunctionaL Annotation at Tufts",
      "database" : "Developmental FunctionaL Annotation at Tufts"
   },
   "wikipedia" : {
      "uri_prefix" : null,
      "generic_url" : "http://en.wikipedia.org/",
      "fullname" : null,
      "datatype" : "entity",
      "abbreviation" : "Wikipedia",
      "example_id" : "Wikipedia:Endoplasmic_reticulum",
      "url_syntax" : "http://en.wikipedia.org/wiki/[example_id]",
      "name" : "Wikipedia",
      "id" : "Wikipedia",
      "url_example" : "http://en.wikipedia.org/wiki/Endoplasmic_reticulum",
      "object" : "entity",
      "database" : "Wikipedia"
   },
   "vmd" : {
      "fullname" : null,
      "generic_url" : "http://phytophthora.vbi.vt.edu",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://vmd.vbi.vt.edu/cgi-bin/browse/browserDetail_new.cgi?gene_id=[example_id]",
      "abbreviation" : "VMD",
      "example_id" : "VMD:109198",
      "database" : "Virginia Bioinformatics Institute Microbial Database",
      "name" : "Virginia Bioinformatics Institute Microbial Database",
      "object" : "entity",
      "url_example" : "http://vmd.vbi.vt.edu/cgi-bin/browse/browserDetail_new.cgi?gene_id=109198",
      "id" : "VMD"
   },
   "dbsnp" : {
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/projects/SNP/snp_ref.cgi?rs=[example_id]",
      "abbreviation" : "dbSNP",
      "example_id" : "dbSNP:rs3131969",
      "fullname" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/projects/SNP",
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "NCBI dbSNP",
      "url_example" : "http://www.ncbi.nlm.nih.gov/projects/SNP/snp_ref.cgi?rs=rs3131969",
      "object" : "entity",
      "id" : "dbSNP",
      "name" : "NCBI dbSNP"
   },
   "grims" : {
      "name" : "IRRI Genetic Resources Information Management System",
      "id" : "GRIMS",
      "object" : "germplasm",
      "url_example" : "https://www.genesys-pgr.org/acn/search2?q=IRGC+90637",
      "database" : "IRRI Genetic Resources Information Management System",
      "uri_prefix" : null,
      "datatype" : "germplasm",
      "generic_url" : "https://www.genesys-pgr.org",
      "fullname" : null,
      "abbreviation" : "GRIMS",
      "example_id" : "GRIMS:90637",
      "url_syntax" : "https://www.genesys-pgr.org/acn/search2?q=IRGC+[example_id]"
   },
   "fypo" : {
      "object" : "entity",
      "url_example" : null,
      "id" : "FYPO",
      "name" : "Fission Yeast Phenotype Ontology",
      "database" : "Fission Yeast Phenotype Ontology",
      "url_syntax" : null,
      "example_id" : "FYPO:0000001",
      "abbreviation" : "FYPO",
      "generic_url" : "http://www.pombase.org/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "bhf-ucl" : {
      "database" : "Cardiovascular Gene Ontology Annotation Initiative",
      "url_example" : null,
      "object" : "entity",
      "id" : "BHF-UCL",
      "name" : "Cardiovascular Gene Ontology Annotation Initiative",
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "BHF-UCL",
      "fullname" : "The Cardiovascular Gene Ontology Annotation Initiative is supported by the British Heart Foundation (BHF) and located at University College London (UCL).",
      "generic_url" : "http://www.ucl.ac.uk/cardiovasculargeneontology/",
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "wbbt" : {
      "database" : "C. elegans gross anatomy",
      "url_example" : null,
      "object" : "metazoan anatomical entity",
      "id" : "WBbt",
      "name" : "C. elegans gross anatomy",
      "url_syntax" : null,
      "example_id" : "WBbt:0005733",
      "abbreviation" : "WBbt",
      "generic_url" : "http://www.wormbase.org/",
      "datatype" : "metazoan anatomical entity",
      "fullname" : null,
      "uri_prefix" : null
   },
   "smd" : {
      "abbreviation" : "SMD",
      "example_id" : null,
      "url_syntax" : null,
      "uri_prefix" : null,
      "generic_url" : "http://genome-www.stanford.edu/microarray",
      "datatype" : "entity",
      "fullname" : null,
      "id" : "SMD",
      "object" : "entity",
      "url_example" : null,
      "name" : "Stanford Microarray Database",
      "database" : "Stanford Microarray Database"
   },
   "ncbi_gi" : {
      "generic_url" : "http://www.ncbi.nlm.nih.gov/",
      "fullname" : null,
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?val=[example_id]",
      "example_id" : "NCBI_gi:113194944",
      "abbreviation" : "NCBI_gi",
      "database" : "NCBI databases",
      "name" : "NCBI databases",
      "url_example" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?val=113194944",
      "object" : "gene",
      "id" : "NCBI_gi"
   },
   "ensemblplants" : {
      "database" : "Ensembl Plants, the Ensembl database for accessing genome-scale data from plants.",
      "name" : "Ensembl Plants, the Ensembl database for accessing genome-scale data from plants.",
      "url_example" : "http://www.ensemblgenomes.org/id/LOC_Os01g22954",
      "object" : "gene",
      "id" : "EnsemblPlants",
      "fullname" : null,
      "generic_url" : "http://plants.ensembl.org/",
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_syntax" : "http://www.ensemblgenomes.org/id/[example_id]",
      "example_id" : "EnsemblPlants:LOC_Os01g22954",
      "abbreviation" : "EnsemblPlants"
   },
   "nc-iubmb" : {
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "NC-IUBMB",
      "generic_url" : "http://www.chem.qmw.ac.uk/iubmb/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_example" : null,
      "object" : "entity",
      "id" : "NC-IUBMB",
      "name" : "Nomenclature Committee of the International Union of Biochemistry and Molecular Biology",
      "database" : "Nomenclature Committee of the International Union of Biochemistry and Molecular Biology"
   },
   "yeastfunc" : {
      "abbreviation" : "YeastFunc",
      "example_id" : null,
      "url_syntax" : null,
      "uri_prefix" : null,
      "generic_url" : "http://func.med.harvard.edu/yeast/",
      "fullname" : null,
      "datatype" : "entity",
      "id" : "YeastFunc",
      "object" : "entity",
      "url_example" : null,
      "name" : "Yeast Function",
      "database" : "Yeast Function"
   },
   "trembl" : {
      "url_syntax" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:[example_id]]",
      "example_id" : "TrEMBL:Q00177",
      "abbreviation" : "TrEMBL",
      "generic_url" : "http://www.ebi.ac.uk/swissprot/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "database" : "TREMBL",
      "url_example" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:Q00177]",
      "object" : "entity",
      "id" : "TR",
      "name" : "TREMBL"
   },
   "imgt_hla" : {
      "generic_url" : "http://www.ebi.ac.uk/imgt/hla",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : "IMGT_HLA:HLA00031",
      "abbreviation" : "IMGT_HLA",
      "database" : "IMGT/HLA human major histocompatibility complex sequence database",
      "name" : "IMGT/HLA human major histocompatibility complex sequence database",
      "url_example" : null,
      "object" : "entity",
      "id" : "IMGT_HLA"
   },
   "wbphenotype" : {
      "object" : "quality",
      "url_example" : "http://www.wormbase.org/species/c_elegans/phenotype/WBPhenotype:0000154",
      "id" : "WBPhenotype",
      "name" : "WormBase phenotype ontology",
      "database" : "WormBase phenotype ontology",
      "url_syntax" : "http://www.wormbase.org/species/c_elegans/phenotype/WBPhenotype:[example_id]",
      "abbreviation" : "WBPhenotype",
      "example_id" : "WBPhenotype:0002117",
      "fullname" : null,
      "generic_url" : "http://www.wormbase.org/",
      "datatype" : "quality",
      "uri_prefix" : null
   },
   "cog" : {
      "database" : "NCBI Clusters of Orthologous Groups",
      "name" : "NCBI Clusters of Orthologous Groups",
      "url_example" : null,
      "object" : "entity",
      "id" : "COG",
      "fullname" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/COG/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "COG"
   },
   "subtilistg" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://genolist.pasteur.fr/SubtiList/",
      "datatype" : "entity",
      "abbreviation" : "SUBTILISTG",
      "example_id" : "SUBTILISTG:accC",
      "url_syntax" : null,
      "database" : "Bacillus subtilis Genome Sequence Project",
      "name" : "Bacillus subtilis Genome Sequence Project",
      "id" : "SUBTILISTG",
      "url_example" : null,
      "object" : "entity"
   },
   "sgd" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.yeastgenome.org/",
      "datatype" : "gene",
      "abbreviation" : "SGD",
      "example_id" : "SGD:S000006169",
      "url_syntax" : "http://www.yeastgenome.org/locus/[example_id]/overview",
      "database" : "Saccharomyces Genome Database",
      "name" : "Saccharomyces Genome Database",
      "id" : "SGD",
      "url_example" : "http://www.yeastgenome.org/locus/S000006169/overview",
      "object" : "gene"
   },
   "go_ref" : {
      "url_example" : "http://purl.obolibrary.org/obo/go/references/0000001",
      "object" : "entity",
      "id" : "GO_REF",
      "name" : "Gene Ontology Database references",
      "database" : "Gene Ontology Database references",
      "url_syntax" : "http://purl.obolibrary.org/obo/go/references/[example_id]",
      "abbreviation" : "GO_REF",
      "example_id" : "0000001",
      "generic_url" : "http://purl.obolibrary.org/obo/go/references/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "go_noctua" : {
      "database" : "GO Noctua",
      "name" : "GO Noctua",
      "url_example" : null,
      "object" : "entity",
      "id" : "GO_Noctua",
      "generic_url" : "https://github.com/geneontology/noctua-models",
      "fullname" : "Manual annotation derived from LEGO annotations",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "abbreviation" : "GO_Noctua",
      "example_id" : null
   },
   "ncbitaxon" : {
      "database" : "NCBI Taxonomy",
      "name" : "NCBI Taxonomy",
      "object" : "entity",
      "url_example" : "http://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=3702",
      "id" : "taxon",
      "datatype" : "entity",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/Taxonomy/taxonomyhome.html/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=[example_id]",
      "example_id" : "taxon:7227",
      "abbreviation" : "NCBITaxon"
   },
   "ncbi_taxid" : {
      "name" : "NCBI Taxonomy",
      "url_example" : "http://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=3702",
      "object" : "entity",
      "id" : "taxon",
      "database" : "NCBI Taxonomy",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/Taxonomy/taxonomyhome.html/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=[example_id]",
      "abbreviation" : "ncbi_taxid",
      "example_id" : "taxon:7227"
   },
   "pr" : {
      "abbreviation" : "PR",
      "example_id" : "PR:000025380",
      "url_syntax" : "http://purl.obolibrary.org/obo/PR_[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.proconsortium.org/pro/pro.shtml",
      "datatype" : "protein",
      "id" : "PR",
      "object" : "protein",
      "url_example" : "http://purl.obolibrary.org/obo/PR_000025380",
      "name" : "Protein Ontology",
      "database" : "Protein Ontology"
   },
   "jcvi_tigrfams" : {
      "url_syntax" : "http://search.jcvi.org/search?p&q=[example_id]",
      "example_id" : "JCVI_TIGRFAMS:TIGR00254",
      "abbreviation" : "JCVI_TIGRFAMS",
      "generic_url" : "http://search.jcvi.org/",
      "fullname" : null,
      "datatype" : "polypeptide region",
      "uri_prefix" : null,
      "url_example" : "http://search.jcvi.org/search?p&q=TIGR00254",
      "object" : "polypeptide region",
      "id" : "JCVI_TIGRFAMS",
      "name" : "TIGRFAMs HMM collection at the J. Craig Venter Institute",
      "database" : "TIGRFAMs HMM collection at the J. Craig Venter Institute"
   },
   "macsc_ref" : {
      "database" : "Maize Genetics and Genomics Database",
      "name" : "Maize Genetics and Genomics Database",
      "id" : "MACSC_REF",
      "url_example" : "http://www.maizegdb.org/cgi-bin/displaytraitrecord.cgi?id=78112",
      "object" : "entity",
      "uri_prefix" : null,
      "generic_url" : "http://www.maizegdb.org/",
      "datatype" : "entity",
      "fullname" : null,
      "abbreviation" : "MACSC_REF",
      "example_id" : "MACSC_REF:78112",
      "url_syntax" : "http://www.maizegdb.org/cgi-bin/displaytraitrecord.cgi?id=[example_id]"
   },
   "gr_qtl" : {
      "fullname" : null,
      "generic_url" : "http://www.gramene.org/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://www.gramene.org/db/qtl/qtl_display?qtl_accession_id=[example_id]",
      "example_id" : "GR_QTL:CQU7",
      "abbreviation" : "GR_QTL",
      "database" : "Gramene",
      "name" : "Gramene",
      "object" : "entity",
      "url_example" : "http://www.gramene.org/db/qtl/qtl_display?qtl_accession_id=CQU7",
      "id" : "GR_QTL"
   },
   "cacao" : {
      "example_id" : "MYCS2:A0QNF5",
      "abbreviation" : "CACAO",
      "url_syntax" : "http://gowiki.tamu.edu/wiki/index.php/[example_id]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://gowiki.tamu.edu/wiki/index.php/Category:CACAO",
      "fullname" : "The Community Assessment of Community Annotation with Ontologies (CACAO) is a project to do large-scale manual community annotation of gene function using the Gene Ontology as a multi-institution student competition.",
      "id" : "CACAO",
      "object" : "entity",
      "url_example" : "http://gowiki.tamu.edu/wiki/index.php/MYCS2:A0QNF5",
      "name" : "Community Assessment of Community Annotation with Ontologies",
      "database" : "Community Assessment of Community Annotation with Ontologies"
   },
   "kegg_enzyme" : {
      "url_example" : "http://www.genome.jp/dbget-bin/www_bget?ec:2.1.1.4",
      "object" : "entity",
      "id" : "KEGG_ENZYME",
      "name" : "KEGG Enzyme Database",
      "database" : "KEGG Enzyme Database",
      "url_syntax" : "http://www.genome.jp/dbget-bin/www_bget?ec:[example_id]",
      "example_id" : "KEGG_ENZYME:2.1.1.4",
      "abbreviation" : "KEGG_ENZYME",
      "datatype" : "entity",
      "generic_url" : "http://www.genome.jp/dbget-bin/www_bfind?enzyme",
      "fullname" : null,
      "uri_prefix" : null
   },
   "ncbi_gene" : {
      "id" : "NCBIGene",
      "url_example" : "http://www.ncbi.nlm.nih.gov/gene/4771",
      "object" : "gene",
      "name" : "NCBI Gene",
      "database" : "NCBI Gene",
      "example_id" : "NCBI_Gene:4771",
      "abbreviation" : "NCBI_Gene",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/gene/[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/",
      "fullname" : null,
      "datatype" : "gene"
   },
   "psort" : {
      "example_id" : null,
      "abbreviation" : "PSORT",
      "url_syntax" : null,
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.psort.org/",
      "datatype" : "entity",
      "database" : "PSORT protein subcellular localization databases and prediction tools for bacteria",
      "id" : "PSORT",
      "url_example" : null,
      "object" : "entity",
      "name" : "PSORT protein subcellular localization databases and prediction tools for bacteria"
   },
   "sgd_locus" : {
      "database" : "Saccharomyces Genome Database",
      "name" : "Saccharomyces Genome Database",
      "url_example" : "http://www.yeastgenome.org/locus/S000006169/overview",
      "object" : "entity",
      "id" : "SGD_LOCUS",
      "generic_url" : "http://www.yeastgenome.org/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.yeastgenome.org/locus/[example_id]/overview",
      "abbreviation" : "SGD_LOCUS",
      "example_id" : "SGD_LOCUS:GAL4"
   },
   "pombase" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.pombase.org/",
      "fullname" : null,
      "datatype" : "gene",
      "example_id" : "PomBase:SPBC11B10.09",
      "abbreviation" : "PomBase",
      "url_syntax" : "http://www.pombase.org/spombe/result/[example_id]",
      "name" : "PomBase",
      "id" : "PomBase",
      "object" : "gene",
      "url_example" : "http://www.pombase.org/spombe/result/SPBC11B10.09",
      "database" : "PomBase"
   },
   "cas" : {
      "example_id" : "CAS:58-08-2",
      "abbreviation" : "CAS",
      "url_syntax" : null,
      "uri_prefix" : null,
      "generic_url" : "http://www.cas.org/expertise/cascontent/registry/index.html",
      "fullname" : "CAS REGISTRY is the most authoritative collection of disclosed chemical substance information, containing more than 54 million organic and inorganic substances and 62 million sequences. CAS REGISTRY covers substances identified from the scientific literature from 1957 to the present, with additional substances going back to the early 1900s.",
      "datatype" : "entity",
      "database" : "CAS Chemical Registry",
      "id" : "CAS",
      "object" : "entity",
      "url_example" : null,
      "name" : "CAS Chemical Registry"
   },
   "geo" : {
      "fullname" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/geo/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/sites/GDSbrowser?acc=[example_id]",
      "example_id" : "GEO:GDS2223",
      "abbreviation" : "GEO",
      "database" : "NCBI Gene Expression Omnibus",
      "name" : "NCBI Gene Expression Omnibus",
      "url_example" : "http://www.ncbi.nlm.nih.gov/sites/GDSbrowser?acc=GDS2223",
      "object" : "entity",
      "id" : "GEO"
   },
   "ddb_ref" : {
      "database" : "dictyBase literature references",
      "id" : "dictyBase_REF",
      "url_example" : "http://dictybase.org/db/cgi-bin/dictyBase/reference/reference.pl?refNo=10157",
      "object" : "entity",
      "name" : "dictyBase literature references",
      "example_id" : "dictyBase_REF:10157",
      "abbreviation" : "DDB_REF",
      "url_syntax" : "http://dictybase.org/db/cgi-bin/dictyBase/reference/reference.pl?refNo=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://dictybase.org",
      "datatype" : "entity",
      "fullname" : null
   },
   "pso_git" : {
      "database" : "GitHub Issue Tracker for PSO",
      "id" : "PSO_GIT",
      "url_example" : "https://github.com/Planteome/plant-stress-ontology/issues/169",
      "object" : "entity",
      "name" : "GitHub Issue Tracker for PSO",
      "example_id" : "PSO_GIT:169",
      "abbreviation" : "PSO_GIT",
      "url_syntax" : "https://github.com/Planteome/plant-stress-ontology/issues/[example_id]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "https://github.com/Planteome/plant-stress-ontology",
      "fullname" : null
   },
   "cazy" : {
      "id" : "CAZY",
      "object" : "entity",
      "url_example" : "http://www.cazy.org/PL11.html",
      "name" : "Carbohydrate Active EnZYmes",
      "database" : "Carbohydrate Active EnZYmes",
      "abbreviation" : "CAZY",
      "example_id" : "CAZY:PL11",
      "url_syntax" : "http://www.cazy.org/[example_id].html",
      "uri_prefix" : null,
      "fullname" : "The CAZy database describes the families of structurally-related catalytic and carbohydrate-binding modules (or functional domains) of enzymes that degrade, modify, or create glycosidic bonds.",
      "generic_url" : "http://www.cazy.org/",
      "datatype" : "entity"
   },
   "sp" : {
      "url_syntax" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:[example_id]]",
      "abbreviation" : "SP",
      "example_id" : "SPTR:12345",
      "datatype" : "entity",
      "generic_url" : "http://srs.ebi.ac.uk",
      "fullname" : null,
      "uri_prefix" : null,
      "database" : "SRS database at EBI",
      "url_example" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:12345]",
      "object" : "entity",
      "id" : "SPTR",
      "name" : "SRS database at EBI"
   },
   "refseq" : {
      "database" : "RefSeq",
      "name" : "RefSeq",
      "id" : "RefSeq",
      "url_example" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?val=XP_001068954",
      "object" : "protein",
      "uri_prefix" : null,
      "datatype" : "protein",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/RefSeq/",
      "fullname" : null,
      "abbreviation" : "RefSeq",
      "example_id" : "RefSeq:XP_001068954",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?val=[example_id]"
   },
   "wbls" : {
      "uri_prefix" : null,
      "datatype" : "nematoda life stage",
      "generic_url" : "http://www.wormbase.org/",
      "fullname" : null,
      "abbreviation" : "WBls",
      "example_id" : "WBls:0000010",
      "url_syntax" : null,
      "name" : "C. elegans development",
      "id" : "WBls",
      "object" : "nematoda life stage",
      "url_example" : null,
      "database" : "C. elegans development"
   },
   "obo_sf2_po" : {
      "uri_prefix" : null,
      "generic_url" : "https://sourceforge.net/p/obo/plant-ontology-po-term-requests/",
      "datatype" : "entity",
      "fullname" : null,
      "example_id" : "OBO_SF2_PO:500",
      "abbreviation" : "OBO_SF2_PO",
      "url_syntax" : "http://sourceforge.net/p/obo/plant-ontology-po-term-requests/[example_id]",
      "database" : "Source Forge OBO Plant Ontology (PO) term request tracker",
      "name" : "Source Forge OBO Plant Ontology (PO) term request tracker",
      "id" : "OBO_SF2_PO",
      "url_example" : "http://sourceforge.net/p/obo/plant-ontology-po-term-requests/500",
      "object" : "entity"
   },
   "ntnu_sb" : {
      "database" : "Norwegian University of Science and Technology, Systems Biology team",
      "name" : "Norwegian University of Science and Technology, Systems Biology team",
      "id" : "NTNU_SB",
      "url_example" : null,
      "object" : "entity",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.ntnu.edu/nt/systemsbiology",
      "fullname" : null,
      "example_id" : null,
      "abbreviation" : "NTNU_SB",
      "url_syntax" : null
   },
   "grin" : {
      "database" : "Germplasm Resources Information Network",
      "name" : "Germplasm Resources Information Network",
      "url_example" : "https://npgsweb.ars-grin.gov/gringlobal/accessiondetail.aspx?id=1882640",
      "object" : "germplasm",
      "id" : "GRIN",
      "generic_url" : "http://www.ars-grin.gov/",
      "fullname" : null,
      "datatype" : "germplasm",
      "uri_prefix" : null,
      "url_syntax" : "https://npgsweb.ars-grin.gov/gringlobal/accessiondetail.aspx?id=[example_id]",
      "example_id" : "GRIN:1882640",
      "abbreviation" : "grin"
   },
   "zfin" : {
      "id" : "ZFIN",
      "url_example" : "http://zfin.org/cgi-bin/ZFIN_jump?record=ZDB-GENE-990415-103",
      "object" : "variation",
      "name" : "Zebrafish Information Network",
      "database" : "Zebrafish Information Network",
      "abbreviation" : "ZFIN",
      "example_id" : "ZFIN:ZDB-GENE-990415-103",
      "url_syntax" : "http://zfin.org/cgi-bin/ZFIN_jump?record=[example_id]",
      "uri_prefix" : null,
      "datatype" : "variation",
      "generic_url" : "http://zfin.org/",
      "fullname" : null
   },
   "biosis" : {
      "url_example" : null,
      "object" : "entity",
      "id" : "BIOSIS",
      "name" : "BIOSIS previews",
      "database" : "BIOSIS previews",
      "url_syntax" : null,
      "abbreviation" : "BIOSIS",
      "example_id" : "BIOSIS:200200247281",
      "fullname" : null,
      "generic_url" : "http://www.biosis.org/",
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "rgdid" : {
      "generic_url" : "http://rgd.mcw.edu/",
      "fullname" : null,
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_syntax" : "http://rgd.mcw.edu/rgdweb/search/search.html?term=[example_id]",
      "example_id" : "RGD:2004",
      "abbreviation" : "RGDID",
      "name" : "Rat Genome Database",
      "url_example" : "http://rgd.mcw.edu/rgdweb/search/search.html?term=2004",
      "object" : "gene",
      "id" : "RGD",
      "database" : "Rat Genome Database"
   },
   "sanger" : {
      "url_example" : null,
      "object" : "entity",
      "id" : "Sanger",
      "name" : "Wellcome Trust Sanger Institute",
      "database" : "Wellcome Trust Sanger Institute",
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "Sanger",
      "generic_url" : "http://www.sanger.ac.uk/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "ena" : {
      "example_id" : "ENA:AA816246",
      "abbreviation" : "ENA",
      "url_syntax" : "http://www.ebi.ac.uk/ena/data/view/[example_id]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.ebi.ac.uk/ena/",
      "fullname" : "ENA is made up of a number of distinct databases that includes EMBL-Bank, the newly established Sequence Read Archive (SRA) and the Trace Archive. International nucleotide sequence database collaboration, comprising ENA-EBI nucleotide sequence data library (EMBL-Bank), DNA DataBank of Japan (DDBJ), and NCBI GenBank",
      "database" : "European Nucleotide Archive",
      "id" : "ENA",
      "url_example" : "http://www.ebi.ac.uk/ena/data/view/AA816246",
      "object" : "entity",
      "name" : "European Nucleotide Archive"
   },
   "ensembl_transcriptid" : {
      "url_syntax" : "http://www.ensembl.org/id/[example_id]",
      "example_id" : "ENSEMBL_TranscriptID:ENST00000371959",
      "abbreviation" : "ENSEMBL_TranscriptID",
      "datatype" : "transcript",
      "generic_url" : "http://www.ensembl.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_example" : "http://www.ensembl.org/id/ENST00000371959",
      "object" : "transcript",
      "id" : "ENSEMBL_TranscriptID",
      "name" : "Ensembl database of automatically annotated genomic data",
      "database" : "Ensembl database of automatically annotated genomic data"
   },
   "ncbigene" : {
      "example_id" : "NCBI_Gene:4771",
      "abbreviation" : "NCBIGene",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/gene/[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/",
      "datatype" : "gene",
      "fullname" : null,
      "id" : "NCBIGene",
      "object" : "gene",
      "url_example" : "http://www.ncbi.nlm.nih.gov/gene/4771",
      "name" : "NCBI Gene",
      "database" : "NCBI Gene"
   },
   "po" : {
      "datatype" : "plant structure development stage",
      "generic_url" : "http://www.planteome.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://browser.planteome.org/amigo/term/PO:[example_id]",
      "example_id" : "PO:0025131",
      "abbreviation" : "PO",
      "name" : "Plant Ontology",
      "url_example" : "http://browser.planteome.org/amigo/term/PO:0025131",
      "object" : "plant structure development stage",
      "id" : "PO",
      "database" : "Plant Ontology"
   },
   "soy_qtl" : {
      "id" : "SOY_QTL",
      "url_example" : "http://www.soybase.org/sbt/search/search_results.php?category=QTLName&search_term=Seedling,+abnormal+1-1",
      "object" : "entity",
      "name" : "SoyBase",
      "database" : "SoyBase",
      "example_id" : "Seedling, abnormal+1-1",
      "abbreviation" : "SOY_QTL",
      "url_syntax" : "http://soybase.org/sbt/search/search_results.php?category=QTLName&search_term=[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://soybase.org/",
      "datatype" : "entity"
   },
   "rad" : {
      "example_id" : "RGD:2004",
      "abbreviation" : "RAD",
      "url_syntax" : "http://rgd.mcw.edu/rgdweb/search/search.html?term=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://rgd.mcw.edu/",
      "datatype" : "gene",
      "fullname" : null,
      "id" : "RGD",
      "url_example" : "http://rgd.mcw.edu/rgdweb/search/search.html?term=2004",
      "object" : "gene",
      "name" : "Rat Genome Database",
      "database" : "Rat Genome Database"
   },
   "roslin_institute" : {
      "generic_url" : "http://www.roslin.ac.uk/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "Roslin_Institute",
      "database" : "Roslin Institute",
      "name" : "Roslin Institute",
      "object" : "entity",
      "url_example" : null,
      "id" : "Roslin_Institute"
   },
   "obi" : {
      "uri_prefix" : null,
      "generic_url" : "http://obi-ontology.org/page/Main_Page",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "OBI:0000038",
      "abbreviation" : "OBI",
      "url_syntax" : null,
      "database" : "Ontology for Biomedical Investigations",
      "name" : "Ontology for Biomedical Investigations",
      "id" : "OBI",
      "object" : "entity",
      "url_example" : null
   },
   "eck" : {
      "id" : "ECK",
      "url_example" : "http://www.ecogene.org/geneInfo.php?eck_id=ECK3746",
      "object" : "gene",
      "name" : "EcoGene Database of Escherichia coli Sequence and Function",
      "database" : "EcoGene Database of Escherichia coli Sequence and Function",
      "abbreviation" : "ECK",
      "example_id" : "ECK:ECK3746",
      "url_syntax" : "http://www.ecogene.org/geneInfo.php?eck_id=[example_id]",
      "uri_prefix" : null,
      "datatype" : "gene",
      "generic_url" : "http://www.ecogene.org/",
      "fullname" : null
   },
   "gene3d" : {
      "name" : "Domain Architecture Classification",
      "id" : "Gene3D",
      "url_example" : "http://gene3d.biochem.ucl.ac.uk/search?mode=family&sterm=3.30.390.30",
      "object" : "entity",
      "database" : "Domain Architecture Classification",
      "uri_prefix" : null,
      "generic_url" : "http://gene3d.biochem.ucl.ac.uk/Gene3D/",
      "fullname" : null,
      "datatype" : "entity",
      "abbreviation" : "Gene3D",
      "example_id" : "Gene3D:3.30.390.30",
      "url_syntax" : "http://gene3d.biochem.ucl.ac.uk/search?mode=family&sterm=[example_id]"
   },
   "plana_ref" : {
      "name" : "Planaria Ontology Database References",
      "object" : "entity",
      "url_example" : "http://purl.obolibrary.org/obo/plana/references/0000001",
      "id" : "PLANA_REF",
      "database" : "Planaria Ontology Database References",
      "datatype" : "entity",
      "generic_url" : "http://purl.obolibrary.org/obo/plana/references/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://purl.obolibrary.org/obo/plana/references/[example_id]",
      "abbreviation" : "PLANA_REF",
      "example_id" : "0000001"
   },
   "issn" : {
      "id" : "ISSN",
      "url_example" : null,
      "object" : "entity",
      "name" : "International Standard Serial Number",
      "database" : "International Standard Serial Number",
      "abbreviation" : "ISSN",
      "example_id" : "ISSN:1234-1231",
      "url_syntax" : null,
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.issn.org/",
      "datatype" : "entity"
   },
   "h-invdb_locus" : {
      "database" : "H-invitational Database",
      "id" : "H-invDB_locus",
      "object" : "entity",
      "url_example" : "http://www.h-invitational.jp/hinv/spsoup/locus_view?hix_id=HIX0014446",
      "name" : "H-invitational Database",
      "abbreviation" : "H-invDB_locus",
      "example_id" : "H-invDB_locus:HIX0014446",
      "url_syntax" : "http://www.h-invitational.jp/hinv/spsoup/locus_view?hix_id=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.h-invitational.jp/",
      "fullname" : null,
      "datatype" : "entity"
   },
   "syngo-ucl" : {
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://geneontology.org/page/syngo-synapse-biology",
      "fullname" : null,
      "example_id" : null,
      "abbreviation" : "SynGO-UCL",
      "url_syntax" : null,
      "name" : "The Synapse Gene Ontology and Annotation Initiative at UCL",
      "id" : "SynGO-UCL",
      "object" : "entity",
      "url_example" : null,
      "database" : "The Synapse Gene Ontology and Annotation Initiative at UCL"
   },
   "ensembl" : {
      "abbreviation" : "ensembl",
      "example_id" : "ENSEMBL:ENSP00000265949",
      "url_syntax" : "http://www.ensembl.org/id/[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.ensembl.org/",
      "datatype" : "transcript",
      "fullname" : null,
      "id" : "ENSEMBL",
      "url_example" : "http://www.ensembl.org/id/ENSP00000265949",
      "object" : "transcript",
      "name" : "Ensembl database of automatically annotated genomic data",
      "database" : "Ensembl database of automatically annotated genomic data"
   },
   "tigr_genprop" : {
      "url_syntax" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenomePropDefinition.cgi?prop_acc=[example_id]",
      "abbreviation" : "TIGR_GenProp",
      "example_id" : "JCVI_GenProp:GenProp0120",
      "fullname" : null,
      "generic_url" : "http://cmr.jcvi.org/",
      "datatype" : "biological_process",
      "uri_prefix" : null,
      "object" : "biological_process",
      "url_example" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenomePropDefinition.cgi?prop_acc=GenProp0120",
      "id" : "JCVI_GenProp",
      "name" : "Genome Properties database at the J. Craig Venter Institute",
      "database" : "Genome Properties database at the J. Craig Venter Institute"
   },
   "broad_neurospora" : {
      "example_id" : "BROAD_NEUROSPORA:7000007580576824",
      "abbreviation" : "Broad_NEUROSPORA",
      "url_syntax" : "http://www.broadinstitute.org/annotation/genome/neurospora/GeneDetails.html?sp=S[example_id]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.broadinstitute.org/annotation/genome/neurospora/MultiHome.html",
      "fullname" : "Neurospora crassa database at the Broad Institute",
      "id" : "Broad_NEUROSPORA",
      "object" : "entity",
      "url_example" : "http://www.broadinstitute.org/annotation/genome/neurospora/GeneDetails.html?sp=S7000007580576824",
      "name" : "Neurospora crassa Database",
      "database" : "Neurospora crassa Database"
   },
   "refgenome" : {
      "database" : "GO Reference Genomes",
      "id" : "RefGenome",
      "object" : "entity",
      "url_example" : null,
      "name" : "GO Reference Genomes",
      "example_id" : null,
      "abbreviation" : "REFGENOME",
      "url_syntax" : null,
      "uri_prefix" : null,
      "generic_url" : "http://www.geneontology.org/GO.refgenome.shtml",
      "datatype" : "entity",
      "fullname" : null
   },
   "kegg_reaction" : {
      "database" : "KEGG Reaction Database",
      "url_example" : "http://www.genome.jp/dbget-bin/www_bget?rn:R02328",
      "object" : "entity",
      "id" : "KEGG_REACTION",
      "name" : "KEGG Reaction Database",
      "url_syntax" : "http://www.genome.jp/dbget-bin/www_bget?rn:[example_id]",
      "example_id" : "KEGG:R02328",
      "abbreviation" : "KEGG_REACTION",
      "datatype" : "entity",
      "generic_url" : "http://www.genome.jp/kegg/reaction/",
      "fullname" : null,
      "uri_prefix" : null
   },
   "geneid" : {
      "generic_url" : "http://www.ncbi.nlm.nih.gov/",
      "fullname" : null,
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/gene/[example_id]",
      "example_id" : "NCBI_Gene:4771",
      "abbreviation" : "GeneID",
      "name" : "NCBI Gene",
      "object" : "gene",
      "url_example" : "http://www.ncbi.nlm.nih.gov/gene/4771",
      "id" : "NCBIGene",
      "database" : "NCBI Gene"
   },
   "tgd_locus" : {
      "id" : "TGD_LOCUS",
      "object" : "entity",
      "url_example" : "http://db.ciliate.org/cgi-bin/locus.pl?locus=PDD1",
      "name" : "Tetrahymena Genome Database",
      "database" : "Tetrahymena Genome Database",
      "abbreviation" : "TGD_LOCUS",
      "example_id" : "TGD_LOCUS:PDD1",
      "url_syntax" : "http://db.ciliate.org/cgi-bin/locus.pl?locus=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.ciliate.org/",
      "datatype" : "entity",
      "fullname" : null
   },
   "genedb" : {
      "url_syntax" : "http://www.genedb.org/gene/[example_id]",
      "example_id" : "PF3D7_1467300",
      "abbreviation" : "GeneDB",
      "generic_url" : "http://www.genedb.org/gene/",
      "fullname" : null,
      "datatype" : "gene",
      "uri_prefix" : null,
      "database" : "GeneDB",
      "url_example" : "http://www.genedb.org/gene/PF3D7_1467300",
      "object" : "gene",
      "id" : "GeneDB",
      "name" : "GeneDB"
   },
   "agricola_id" : {
      "database" : "AGRICultural OnLine Access",
      "name" : "AGRICultural OnLine Access",
      "object" : "entity",
      "url_example" : null,
      "id" : "AGRICOLA_ID",
      "fullname" : null,
      "generic_url" : "http://agricola.nal.usda.gov/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "abbreviation" : "AGRICOLA_ID",
      "example_id" : "AGRICOLA_NAL:TP248.2 P76 v.14"
   },
   "subtilist" : {
      "abbreviation" : "SUBTILIST",
      "example_id" : "SUBTILISTG:BG11384",
      "url_syntax" : null,
      "uri_prefix" : null,
      "datatype" : "protein",
      "generic_url" : "http://genolist.pasteur.fr/SubtiList/",
      "fullname" : null,
      "database" : "Bacillus subtilis Genome Sequence Project",
      "id" : "SUBTILIST",
      "url_example" : null,
      "object" : "protein",
      "name" : "Bacillus subtilis Genome Sequence Project"
   },
   "parkinsonsuk-ucl" : {
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "ParkinsonsUK-UCL",
      "fullname" : null,
      "generic_url" : "http://www.ucl.ac.uk/functional-gene-annotation/neurological",
      "datatype" : "entity",
      "uri_prefix" : null,
      "object" : "entity",
      "url_example" : null,
      "id" : "ParkinsonsUK-UCL",
      "name" : "Parkinsons Disease Gene Ontology Initiative",
      "database" : "Parkinsons Disease Gene Ontology Initiative"
   },
   "um-bbd_pathwayid" : {
      "example_id" : "UM-BBD_pathwayID:acr",
      "abbreviation" : "UM-BBD_pathwayID",
      "url_syntax" : "http://eawag-bbd.ethz.ch/[example_id]/[example_id]_map.html",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://eawag-bbd.ethz.ch/",
      "fullname" : null,
      "id" : "UM-BBD_pathwayID",
      "object" : "entity",
      "url_example" : "http://eawag-bbd.ethz.ch/acr/acr_map.html",
      "name" : "EAWAG Biocatalysis/Biodegradation Database",
      "database" : "EAWAG Biocatalysis/Biodegradation Database"
   },
   "ensembl_geneid" : {
      "example_id" : "ENSEMBL_GeneID:ENSG00000126016",
      "abbreviation" : "ENSEMBL_GeneID",
      "url_syntax" : "http://www.ensembl.org/id/[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.ensembl.org/",
      "fullname" : null,
      "datatype" : "gene",
      "id" : "ENSEMBL_GeneID",
      "url_example" : "http://www.ensembl.org/id/ENSG00000126016",
      "object" : "gene",
      "name" : "Ensembl database of automatically annotated genomic data",
      "database" : "Ensembl database of automatically annotated genomic data"
   },
   "intact" : {
      "object" : "protein-containing complex",
      "url_example" : "http://www.ebi.ac.uk/complexportal/complex/EBI-10205244",
      "id" : "IntAct",
      "name" : "IntAct protein interaction database",
      "database" : "IntAct protein interaction database",
      "url_syntax" : "http://www.ebi.ac.uk/complexportal/complex/[example_id]",
      "example_id" : "IntAct:EBI-10205244",
      "abbreviation" : "IntAct",
      "generic_url" : "http://www.ebi.ac.uk/intact/",
      "fullname" : null,
      "datatype" : "protein-containing complex",
      "uri_prefix" : null
   },
   "po_ref" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://planteome.org/po_ref",
      "datatype" : "entity",
      "abbreviation" : "PO_REF",
      "example_id" : "PO_REF:00001",
      "url_syntax" : "http://planteome.org/po_ref/[example_id]",
      "database" : "Plant Ontology custom references",
      "name" : "Plant Ontology custom references",
      "id" : "PO_REF",
      "url_example" : "http://planteome.org/po_ref/00001",
      "object" : "entity"
   },
   "pfamb" : {
      "abbreviation" : "PfamB",
      "example_id" : "PfamB:PB014624",
      "url_syntax" : null,
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.sanger.ac.uk/Software/Pfam/",
      "datatype" : "entity",
      "id" : "PfamB",
      "url_example" : null,
      "object" : "entity",
      "name" : "Pfam-B supplement to Pfam",
      "database" : "Pfam-B supplement to Pfam"
   },
   "dictybase" : {
      "uri_prefix" : null,
      "generic_url" : "http://dictybase.org",
      "datatype" : "gene",
      "fullname" : null,
      "abbreviation" : "DictyBase",
      "example_id" : "dictyBase:DDB_G0277859",
      "url_syntax" : "http://dictybase.org/gene/[example_id]",
      "database" : "dictyBase",
      "name" : "dictyBase",
      "id" : "dictyBase",
      "object" : "gene",
      "url_example" : "http://dictybase.org/gene/DDB_G0277859"
   },
   "patric" : {
      "generic_url" : "http://patric.vbi.vt.edu",
      "fullname" : "PathoSystems Resource Integration Center at the Virginia Bioinformatics Institute",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://patric.vbi.vt.edu/gene/overview.php?fid=[example_id]",
      "abbreviation" : "PATRIC",
      "example_id" : "PATRIC:cds.000002.436951",
      "name" : "PathoSystems Resource Integration Center",
      "object" : "entity",
      "url_example" : "http://patric.vbi.vt.edu/gene/overview.php?fid=cds.000002.436951",
      "id" : "PATRIC",
      "database" : "PathoSystems Resource Integration Center"
   },
   "biocyc" : {
      "object" : "entity",
      "url_example" : "http://biocyc.org/META/NEW-IMAGE?type=PATHWAY&object=PWY-5271",
      "id" : "BioCyc",
      "name" : "BioCyc collection of metabolic pathway databases",
      "database" : "BioCyc collection of metabolic pathway databases",
      "url_syntax" : "http://biocyc.org/META/NEW-IMAGE?type=PATHWAY&object=[example_id]",
      "example_id" : "BioCyc:PWY-5271",
      "abbreviation" : "BioCyc",
      "generic_url" : "http://biocyc.org/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null
   },
   "pdb" : {
      "abbreviation" : "PDB",
      "example_id" : "PDB:1A4U",
      "url_syntax" : "http://www.rcsb.org/pdb/cgi/explore.cgi?pdbId=[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.rcsb.org/pdb/",
      "datatype" : "protein",
      "database" : "Protein Data Bank",
      "id" : "PDB",
      "object" : "protein",
      "url_example" : "http://www.rcsb.org/pdb/cgi/explore.cgi?pdbId=1A4U",
      "name" : "Protein Data Bank"
   },
   "agi_locuscode" : {
      "generic_url" : "http://www.arabidopsis.org",
      "fullname" : "Comprises TAIR, TIGR and MIPS",
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_syntax" : "http://arabidopsis.org/servlets/TairObject?type=locus&name=[example_id]",
      "abbreviation" : "AGI_LocusCode",
      "example_id" : "AGI_LocusCode:At2g17950",
      "name" : "Arabidopsis Genome Initiative",
      "url_example" : "http://arabidopsis.org/servlets/TairObject?type=locus&name=At2g17950",
      "object" : "gene",
      "id" : "AGI_LocusCode",
      "database" : "Arabidopsis Genome Initiative"
   },
   "unipathway" : {
      "database" : "UniPathway",
      "id" : "UniPathway",
      "object" : "biological_process",
      "url_example" : "http://www.grenoble.prabi.fr/obiwarehouse/unipathway/upa?upid=UPA00155",
      "name" : "UniPathway",
      "abbreviation" : "UniPathway",
      "example_id" : "UniPathway:UPA00155",
      "url_syntax" : "http://www.grenoble.prabi.fr/obiwarehouse/unipathway/upa?upid=[example_id]",
      "uri_prefix" : null,
      "fullname" : "UniPathway is a a metabolic door to UniProtKB/Swiss-Prot, a curated resource of metabolic pathways for the UniProtKB/Swiss-Prot knowledgebase.",
      "generic_url" : "http://www.grenoble.prabi.fr/obiwarehouse/unipathway",
      "datatype" : "biological_process"
   },
   "um-bbd_enzymeid" : {
      "name" : "EAWAG Biocatalysis/Biodegradation Database",
      "id" : "UM-BBD_enzymeID",
      "object" : "entity",
      "url_example" : "http://eawag-bbd.ethz.ch/servlets/pageservlet?ptype=ep&enzymeID=e0230",
      "database" : "EAWAG Biocatalysis/Biodegradation Database",
      "uri_prefix" : null,
      "generic_url" : "http://eawag-bbd.ethz.ch/",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "UM-BBD_enzymeID:e0413",
      "abbreviation" : "UM-BBD_enzymeID",
      "url_syntax" : "http://eawag-bbd.ethz.ch/servlets/pageservlet?ptype=ep&enzymeID=[example_id]"
   },
   "biopixie_mefit" : {
      "database" : "biological Process Inference from eXperimental Interaction Evidence/Microarray Experiment Functional Integration Technology",
      "id" : "bioPIXIE_MEFIT",
      "url_example" : null,
      "object" : "entity",
      "name" : "biological Process Inference from eXperimental Interaction Evidence/Microarray Experiment Functional Integration Technology",
      "example_id" : null,
      "abbreviation" : "bioPIXIE_MEFIT",
      "url_syntax" : null,
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://avis.princeton.edu/mefit/",
      "fullname" : null
   },
   "ro" : {
      "url_syntax" : "http://purl.obolibrary.org/obo/RO_[example_id]",
      "abbreviation" : "RO",
      "example_id" : "RO:0002211",
      "generic_url" : "http://purl.obolibrary.org/obo/ro",
      "fullname" : "A collection of relations used across OBO ontologies",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_example" : "http://purl.obolibrary.org/obo/RO_0002211",
      "object" : "entity",
      "id" : "RO",
      "name" : "OBO Relation Ontology Ontology",
      "database" : "OBO Relation Ontology Ontology"
   },
   "vega" : {
      "url_example" : "http://vega.sanger.ac.uk/id/OTTHUMP00000000661",
      "object" : "entity",
      "id" : "VEGA",
      "name" : "Vertebrate Genome Annotation database",
      "database" : "Vertebrate Genome Annotation database",
      "url_syntax" : "http://vega.sanger.ac.uk/id/[example_id]",
      "example_id" : "VEGA:OTTHUMP00000000661",
      "abbreviation" : "VEGA",
      "datatype" : "entity",
      "generic_url" : "http://vega.sanger.ac.uk/index.html",
      "fullname" : null,
      "uri_prefix" : null
   },
   "tgd" : {
      "fullname" : null,
      "generic_url" : "http://www.ciliate.org/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "TGD",
      "name" : "Tetrahymena Genome Database",
      "object" : "entity",
      "url_example" : null,
      "id" : "TGD",
      "database" : "Tetrahymena Genome Database"
   },
   "complexportal" : {
      "url_syntax" : "https://www.ebi.ac.uk/complexportal/complex/[example_id]",
      "example_id" : "ComplexPortal:CPX-2158",
      "abbreviation" : "ComplexPortal",
      "generic_url" : "https://www.ebi.ac.uk/complexportal",
      "datatype" : "macromolecular complex",
      "fullname" : null,
      "uri_prefix" : null,
      "url_example" : "https://www.ebi.ac.uk/complexportal/complex/CPX-2158",
      "object" : "macromolecular complex",
      "id" : "ComplexPortal",
      "name" : "Complex Portal database of macromolecular complexes",
      "database" : "Complex Portal database of macromolecular complexes"
   },
   "resid" : {
      "example_id" : "RESID:AA0062",
      "abbreviation" : "RESID",
      "url_syntax" : null,
      "uri_prefix" : null,
      "generic_url" : "ftp://ftp.ncifcrf.gov/pub/users/residues/",
      "fullname" : null,
      "datatype" : "entity",
      "database" : "RESID Database of Protein Modifications",
      "id" : "RESID",
      "url_example" : null,
      "object" : "entity",
      "name" : "RESID Database of Protein Modifications"
   },
   "uniparc" : {
      "generic_url" : "http://www.uniprot.org/uniparc/",
      "datatype" : "entity",
      "fullname" : "A non-redundant archive of protein sequences extracted from Swiss-Prot, TrEMBL, PIR-PSD, EMBL, Ensembl, IPI, PDB, RefSeq, FlyBase, WormBase, European Patent Office, United States Patent and Trademark Office, and Japanese Patent Office",
      "uri_prefix" : null,
      "url_syntax" : "http://www.uniprot.org/uniparc/[example_id]",
      "abbreviation" : "UniParc",
      "example_id" : "UniParc:UPI000000000A",
      "name" : "UniProt Archive",
      "object" : "entity",
      "url_example" : "http://www.uniprot.org/uniparc/UPI000000000A",
      "id" : "UniParc",
      "database" : "UniProt Archive"
   },
   "co_125" : {
      "database" : "Crop Ontology CGIAR Musa Anatomy",
      "name" : "Crop Ontology CGIAR Musa Anatomy",
      "object" : "entity",
      "url_example" : "http://www.cropontology.org/ontology/CO_125:0000000",
      "id" : "CO_125",
      "generic_url" : "http://www.cropontology.org/ontology/CO_125:0000000/CGIAR_Musa_anatomy",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "abbreviation" : "CO_125",
      "example_id" : "CO_125:0000002"
   },
   "rhea" : {
      "name" : "Rhea, the Annotated Reactions Database",
      "id" : "RHEA",
      "object" : "entity",
      "url_example" : "http://www.rhea-db.org/reaction.xhtml?id=25811",
      "database" : "Rhea, the Annotated Reactions Database",
      "uri_prefix" : null,
      "generic_url" : "http://www.rhea-db.org",
      "datatype" : "entity",
      "fullname" : "Rhea is a manually annotated database of chemical reactions. All data in Rhea is freely accessible and available for anyone to use.",
      "abbreviation" : "RHEA",
      "example_id" : "RHEA:25811",
      "url_syntax" : "http://www.rhea-db.org/reaction.xhtml?id=[example_id]"
   },
   "tigr" : {
      "database" : "J. Craig Venter Institute",
      "name" : "J. Craig Venter Institute",
      "id" : "JCVI",
      "url_example" : null,
      "object" : "entity",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.jcvi.org/",
      "fullname" : null,
      "example_id" : null,
      "abbreviation" : "TIGR",
      "url_syntax" : null
   },
   "um-bbd" : {
      "url_syntax" : null,
      "abbreviation" : "UM-BBD",
      "example_id" : null,
      "fullname" : null,
      "generic_url" : "http://eawag-bbd.ethz.ch/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_example" : null,
      "object" : "entity",
      "id" : "UM-BBD",
      "name" : "EAWAG Biocatalysis/Biodegradation Database",
      "database" : "EAWAG Biocatalysis/Biodegradation Database"
   },
   "eurofung" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.eurofung.net/option=com_content&task=section&id=3&Itemid=4",
      "datatype" : "entity",
      "fullname" : null,
      "example_id" : null,
      "abbreviation" : "Eurofung",
      "url_syntax" : null,
      "database" : "Eurofungbase community annotation",
      "name" : "Eurofungbase community annotation",
      "id" : "Eurofung",
      "url_example" : null,
      "object" : "entity"
   },
   "medline" : {
      "database" : "Medline literature database",
      "object" : "entity",
      "url_example" : null,
      "id" : "MEDLINE",
      "name" : "Medline literature database",
      "url_syntax" : null,
      "example_id" : "MEDLINE:20572430",
      "abbreviation" : "MEDLINE",
      "generic_url" : "http://www.nlm.nih.gov/databases/databases_medline.html",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "enzyme" : {
      "database" : "Swiss Institute of Bioinformatics enzyme database",
      "name" : "Swiss Institute of Bioinformatics enzyme database",
      "id" : "ENZYME",
      "url_example" : "http://www.expasy.ch/cgi-bin/nicezyme.pl?1.1.1.1",
      "object" : "entity",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.expasy.ch/",
      "fullname" : null,
      "abbreviation" : "ENZYME",
      "example_id" : "ENZYME:EC 1.1.1.1",
      "url_syntax" : "http://www.expasy.ch/cgi-bin/nicezyme.pl?[example_id]"
   },
   "paint_ref" : {
      "name" : "Phylogenetic Annotation INference Tool References",
      "object" : "entity",
      "url_example" : "http://www.pantherdb.org/panther/lookupId.jsp?id=PTHR23266",
      "id" : "PAINT_REF",
      "database" : "Phylogenetic Annotation INference Tool References",
      "datatype" : "entity",
      "generic_url" : "http://www.pantherdb.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.pantherdb.org/panther/lookupId.jsp?id=PTHR[example_id]",
      "example_id" : "PAINT_REF:23266",
      "abbreviation" : "PAINT_REF"
   },
   "prosite" : {
      "abbreviation" : "Prosite",
      "example_id" : "Prosite:PS00365",
      "url_syntax" : "http://www.expasy.ch/cgi-bin/prosite-search-ac?[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.expasy.ch/prosite/",
      "datatype" : "polypeptide region",
      "database" : "Prosite database of protein families and domains",
      "id" : "Prosite",
      "url_example" : "http://www.expasy.ch/cgi-bin/prosite-search-ac?PS00365",
      "object" : "polypeptide region",
      "name" : "Prosite database of protein families and domains"
   },
   "kegg_ligand" : {
      "generic_url" : "http://www.genome.ad.jp/kegg/docs/upd_ligand.html",
      "fullname" : null,
      "datatype" : "chemical entity",
      "uri_prefix" : null,
      "url_syntax" : "http://www.genome.jp/dbget-bin/www_bget?cpd:[example_id]",
      "abbreviation" : "KEGG_LIGAND",
      "example_id" : "KEGG_LIGAND:C00577",
      "database" : "KEGG LIGAND Database",
      "name" : "KEGG LIGAND Database",
      "object" : "chemical entity",
      "url_example" : "http://www.genome.jp/dbget-bin/www_bget?cpd:C00577",
      "id" : "KEGG_LIGAND"
   },
   "ppi" : {
      "uri_prefix" : null,
      "generic_url" : "http://genome.pseudomonas-syringae.org/",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : null,
      "abbreviation" : "PPI",
      "url_syntax" : null,
      "database" : "Pseudomonas syringae community annotation project",
      "name" : "Pseudomonas syringae community annotation project",
      "id" : "PPI",
      "object" : "entity",
      "url_example" : null
   },
   "maizegdb_stock" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.maizegdb.org/",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "MaizeGDB_stock:12098",
      "abbreviation" : "MaizeGDB_stock",
      "url_syntax" : "http://maizegdb.org/data_center/stock?id=[example_id]",
      "name" : "Maize Genetics and Genomics Database",
      "id" : "MaizeGDB_stock",
      "url_example" : "http://maizegdb.org/data_center/stock?id=12098",
      "object" : "entity",
      "database" : "Maize Genetics and Genomics Database"
   },
   "jaiswal_lab" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://wiki.plantontology.org/index.php/PO_REF:00008",
      "datatype" : "entity",
      "example_id" : "Jaiswal_Lab:gene00002",
      "abbreviation" : "Jaiswal_Lab",
      "url_syntax" : "http://wiki.plantontology.org/index.php/PO_REF:00008",
      "name" : "Jaiswal_Lab",
      "id" : "Jaiswal_Lab",
      "object" : "entity",
      "url_example" : "http://wiki.plantontology.org/index.php/PO_REF:00008",
      "database" : "Jaiswal_Lab"
   },
   "ecocyc_ref" : {
      "id" : "EcoCyc_REF",
      "url_example" : "http://biocyc.org/ECOLI/reference.html?type=CITATION-FRAME&object=COLISALII",
      "object" : "entity",
      "name" : "Encyclopedia of E. coli metabolism",
      "database" : "Encyclopedia of E. coli metabolism",
      "example_id" : "EcoCyc_REF:COLISALII",
      "abbreviation" : "ECOCYC_REF",
      "url_syntax" : "http://biocyc.org/ECOLI/reference.html?type=CITATION-FRAME&object=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://ecocyc.org/",
      "datatype" : "entity",
      "fullname" : null
   },
   "mo" : {
      "name" : "MGED Ontology",
      "object" : "entity",
      "url_example" : "http://mged.sourceforge.net/ontologies/MGEDontology.php#Action",
      "id" : "MO",
      "database" : "MGED Ontology",
      "datatype" : "entity",
      "generic_url" : "http://mged.sourceforge.net/ontologies/MGEDontology.php",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://mged.sourceforge.net/ontologies/MGEDontology.php#[example_id]",
      "example_id" : "MO:Action",
      "abbreviation" : "MO"
   },
   "tigr_cmr" : {
      "uri_prefix" : null,
      "generic_url" : "http://cmr.jcvi.org/",
      "datatype" : "protein",
      "fullname" : null,
      "example_id" : "JCVI_CMR:VCA0557",
      "abbreviation" : "TIGR_CMR",
      "url_syntax" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenePage.cgi?locus=[example_id]",
      "name" : "EGAD database at the J. Craig Venter Institute",
      "id" : "JCVI_CMR",
      "url_example" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenePage.cgi?locus=VCA0557",
      "object" : "protein",
      "database" : "EGAD database at the J. Craig Venter Institute"
   },
   "rebase" : {
      "id" : "REBASE",
      "url_example" : "http://rebase.neb.com/rebase/enz/EcoRI.html",
      "object" : "entity",
      "name" : "REBASE restriction enzyme database",
      "database" : "REBASE restriction enzyme database",
      "abbreviation" : "REBASE",
      "example_id" : "REBASE:EcoRI",
      "url_syntax" : "http://rebase.neb.com/rebase/enz/[example_id].html",
      "uri_prefix" : null,
      "generic_url" : "http://rebase.neb.com/rebase/rebase.html",
      "fullname" : null,
      "datatype" : "entity"
   },
   "metacyc" : {
      "database" : "Metabolic Encyclopedia of metabolic and other pathways",
      "name" : "Metabolic Encyclopedia of metabolic and other pathways",
      "id" : "MetaCyc",
      "object" : "entity",
      "url_example" : "http://biocyc.org/META/NEW-IMAGE?type=NIL&object=GLUTDEG-PWY",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://metacyc.org/",
      "datatype" : "entity",
      "abbreviation" : "METACYC",
      "example_id" : "MetaCyc:GLUTDEG-PWY",
      "url_syntax" : "http://biocyc.org/META/NEW-IMAGE?type=NIL&object=[example_id]"
   },
   "brenda" : {
      "name" : "BRENDA, The Comprehensive Enzyme Information System",
      "id" : "BRENDA",
      "object" : "catalytic activity",
      "url_example" : "http://www.brenda-enzymes.info/php/result_flat.php4?ecno=4.2.1.3",
      "database" : "BRENDA, The Comprehensive Enzyme Information System",
      "uri_prefix" : null,
      "datatype" : "catalytic activity",
      "generic_url" : "http://www.brenda-enzymes.info",
      "fullname" : null,
      "example_id" : "BRENDA:4.2.1.3",
      "abbreviation" : "BRENDA",
      "url_syntax" : "http://www.brenda-enzymes.info/php/result_flat.php4?ecno=[example_id]"
   },
   "ec" : {
      "uri_prefix" : null,
      "datatype" : "catalytic activity",
      "generic_url" : "http://enzyme.expasy.org/",
      "fullname" : null,
      "example_id" : "EC:1.4.3.6",
      "abbreviation" : "EC",
      "url_syntax" : "http://www.expasy.org/enzyme/[example_id]",
      "database" : "Enzyme Commission",
      "name" : "Enzyme Commission",
      "id" : "EC",
      "url_example" : "http://www.expasy.org/enzyme/1.4.3.6",
      "object" : "catalytic activity"
   },
   "um-bbd_reactionid" : {
      "database" : "EAWAG Biocatalysis/Biodegradation Database",
      "name" : "EAWAG Biocatalysis/Biodegradation Database",
      "object" : "entity",
      "url_example" : "http://eawag-bbd.ethz.ch/servlets/pageservlet?ptype=r&reacID=r0129",
      "id" : "UM-BBD_reactionID",
      "datatype" : "entity",
      "generic_url" : "http://eawag-bbd.ethz.ch/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://eawag-bbd.ethz.ch/servlets/pageservlet?ptype=r&reacID=[example_id]",
      "abbreviation" : "UM-BBD_reactionID",
      "example_id" : "UM-BBD_reactionID:r0129"
   },
   "cosmoss_ppv1.2" : {
      "generic_url" : "https://www.cosmoss.org/annotation/genonaut",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "https://www.cosmoss.org/annotation/genonaut?accession=[example_id]&version=V1.2",
      "example_id" : "cosmoss_PpV1.2:Pp1s47_77V2.1",
      "abbreviation" : "cosmoss_PpV1.2",
      "database" : "plantco.de|cosmoss.org",
      "name" : "plantco.de|cosmoss.org",
      "url_example" : "https://www.cosmoss.org/annotation/genonaut?accession=Pp1s53_22V2.1&version=V1.2",
      "object" : "entity",
      "id" : "cosmoss_PpV1.2"
   },
   "kegg" : {
      "name" : "Kyoto Encyclopedia of Genes and Genomes",
      "id" : "KEGG",
      "url_example" : null,
      "object" : "entity",
      "database" : "Kyoto Encyclopedia of Genes and Genomes",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.genome.ad.jp/kegg/",
      "datatype" : "entity",
      "abbreviation" : "KEGG",
      "example_id" : null,
      "url_syntax" : null
   },
   "goc-owl" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.geneontology.org/",
      "datatype" : "entity",
      "abbreviation" : "GOC-OWL",
      "example_id" : null,
      "url_syntax" : null,
      "database" : "Gene Ontology Consortium - Logical inferences",
      "name" : "Gene Ontology Consortium - Logical inferences",
      "id" : "GOC-OWL",
      "url_example" : null,
      "object" : "entity"
   },
   "uniprotkb" : {
      "name" : "Universal Protein Knowledgebase",
      "object" : "protein",
      "url_example" : "http://www.uniprot.org/uniprot/P51587",
      "id" : "UniProtKB",
      "database" : "Universal Protein Knowledgebase",
      "fullname" : "A central repository of protein sequence and function created by joining the information contained in Swiss-Prot, TrEMBL, and PIR database",
      "generic_url" : "http://www.uniprot.org",
      "datatype" : "protein",
      "uri_prefix" : null,
      "url_syntax" : "http://www.uniprot.org/uniprot/[example_id]",
      "example_id" : "UniProtKB:P51587",
      "abbreviation" : "UniProtKB"
   },
   "unirule" : {
      "url_syntax" : "http://www.uniprot.org/unirule/[example_id]",
      "example_id" : "UniRule:UR000107224",
      "abbreviation" : "UniRule",
      "datatype" : "entity",
      "generic_url" : "http://www.uniprot.org/unirule",
      "fullname" : null,
      "uri_prefix" : null,
      "database" : "Manually curated rules for automatic annotation of UniProtKB unreviewed entries",
      "object" : "entity",
      "url_example" : "http://www.uniprot.org/unirule/UR000107224",
      "id" : "UniRule",
      "name" : "Manually curated rules for automatic annotation of UniProtKB unreviewed entries"
   },
   "psi-mod" : {
      "abbreviation" : "PSI-MOD",
      "example_id" : "MOD:00219",
      "url_syntax" : "http://www.ebi.ac.uk/ontology-lookup/?termId=MOD:[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://psidev.sourceforge.net/mod/",
      "datatype" : "entity",
      "fullname" : null,
      "database" : "Proteomics Standards Initiative protein modification ontology",
      "id" : "PSI-MOD",
      "object" : "entity",
      "url_example" : "http://www.ebi.ac.uk/ontology-lookup/?termId=MOD:00219",
      "name" : "Proteomics Standards Initiative protein modification ontology"
   },
   "pubchem_compound" : {
      "id" : "PubChem_Compound",
      "object" : "chemical entity",
      "url_example" : "http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?CMD=search&DB=pccompound&term=2244",
      "name" : "NCBI PubChem database of chemical structures",
      "database" : "NCBI PubChem database of chemical structures",
      "example_id" : "PubChem_Compound:2244",
      "abbreviation" : "PubChem_Compound",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?CMD=search&DB=pccompound&term=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://pubchem.ncbi.nlm.nih.gov/",
      "datatype" : "chemical entity",
      "fullname" : null
   },
   "ncbi_locus_tag" : {
      "name" : "NCBI locus tag",
      "url_example" : null,
      "object" : "entity",
      "id" : "NCBI_locus_tag",
      "database" : "NCBI locus tag",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : "NCBI_locus_tag:CTN_0547",
      "abbreviation" : "NCBI_locus_tag"
   },
   "mips_funcat" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://mips.gsf.de/proj/funcatDB/",
      "datatype" : "entity",
      "abbreviation" : "MIPS_funcat",
      "example_id" : "MIPS_funcat:11.02",
      "url_syntax" : "http://mips.gsf.de/cgi-bin/proj/funcatDB/search_advanced.pl?action=2&wert=[example_id]",
      "name" : "MIPS Functional Catalogue",
      "id" : "MIPS_funcat",
      "object" : "entity",
      "url_example" : "http://mips.gsf.de/cgi-bin/proj/funcatDB/search_advanced.pl?action=2&wert=11.02",
      "database" : "MIPS Functional Catalogue"
   },
   "fma" : {
      "database" : "Foundational Model of Anatomy",
      "name" : "Foundational Model of Anatomy",
      "url_example" : null,
      "object" : "entity",
      "id" : "FMA",
      "fullname" : null,
      "generic_url" : "http://sig.biostr.washington.edu/projects/fm/index.html",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : "FMA:61905",
      "abbreviation" : "FMA"
   },
   "h-invdb" : {
      "database" : "H-invitational Database",
      "url_example" : null,
      "object" : "entity",
      "id" : "H-invDB",
      "name" : "H-invitational Database",
      "url_syntax" : null,
      "abbreviation" : "H-invDB",
      "example_id" : null,
      "fullname" : null,
      "generic_url" : "http://www.h-invitational.jp/",
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "flybase" : {
      "generic_url" : "http://flybase.org/",
      "datatype" : "gene",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://flybase.org/reports/[example_id].html",
      "example_id" : "FB:FBgn0000024",
      "abbreviation" : "FLYBASE",
      "database" : "FlyBase",
      "name" : "FlyBase",
      "url_example" : "http://flybase.org/reports/FBgn0000024.html",
      "object" : "gene",
      "id" : "FB"
   },
   "emapa" : {
      "url_syntax" : "http://www.informatics.jax.org/vocab/gxd/anatomy/EMAPA:[example_id]",
      "example_id" : "EMAPA:16032",
      "abbreviation" : "EMAPA",
      "datatype" : "anatomical entity",
      "generic_url" : "http://emouseatlas.org/",
      "fullname" : "A time-independent Mouse Anatomical Dictionary; part of Gene Expression Database",
      "uri_prefix" : null,
      "database" : "Mouse gross anatomy and development, abstract",
      "object" : "anatomical entity",
      "url_example" : "http://www.informatics.jax.org/vocab/gxd/anatomy/EMAPA:16894",
      "id" : "EMAPA",
      "name" : "Mouse gross anatomy and development, abstract"
   },
   "poc" : {
      "name" : "Plant Ontology Consortium",
      "id" : "POC",
      "url_example" : null,
      "object" : "entity",
      "database" : "Plant Ontology Consortium",
      "uri_prefix" : null,
      "generic_url" : "http://www.plantontology.org/",
      "datatype" : "entity",
      "fullname" : null,
      "example_id" : null,
      "abbreviation" : "POC",
      "url_syntax" : null
   },
   "multifun" : {
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://genprotec.mbl.edu/files/MultiFun.html",
      "fullname" : null,
      "example_id" : null,
      "abbreviation" : "MultiFun",
      "url_syntax" : null,
      "name" : "MultiFun cell function assignment schema",
      "id" : "MultiFun",
      "url_example" : null,
      "object" : "entity",
      "database" : "MultiFun cell function assignment schema"
   },
   "maizegdb" : {
      "database" : "MaizeGDB",
      "name" : "MaizeGDB",
      "id" : "MaizeGDB",
      "url_example" : "http://maizegdb.org/gene_center/gene/12098",
      "object" : "entity",
      "uri_prefix" : null,
      "generic_url" : "http://www.maizegdb.org",
      "fullname" : null,
      "datatype" : "entity",
      "abbreviation" : "MaizeGDB",
      "example_id" : "MaizeGDB:12098",
      "url_syntax" : "http://maizegdb.org/gene_center/gene/[example_id]"
   },
   "agbase" : {
      "object" : "entity",
      "url_example" : null,
      "id" : "AgBase",
      "name" : "AgBase resource for functional analysis of agricultural plant and animal gene products",
      "database" : "AgBase resource for functional analysis of agricultural plant and animal gene products",
      "url_syntax" : "http://www.agbase.msstate.edu/cgi-bin/getEntry.pl?db_pick=[ChickGO/MaizeGO]&uid=[example_id]",
      "abbreviation" : "AgBase",
      "example_id" : null,
      "fullname" : null,
      "generic_url" : "http://www.agbase.msstate.edu/",
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "prints" : {
      "url_syntax" : "http://www.bioinf.manchester.ac.uk/cgi-bin/dbbrowser/sprint/searchprintss.cgi?display_opts=Prints&category=None&queryform=false&regexpr=off&prints_accn=[example_id]",
      "example_id" : "PRINTS:PR00025",
      "abbreviation" : "PRINTS",
      "generic_url" : "http://www.bioinf.manchester.ac.uk/dbbrowser/PRINTS/",
      "fullname" : null,
      "datatype" : "polypeptide region",
      "uri_prefix" : null,
      "url_example" : "http://www.bioinf.manchester.ac.uk/cgi-bin/dbbrowser/sprint/searchprintss.cgi?display_opts=Prints&category=None&queryform=false&regexpr=off&prints_accn=PR00025",
      "object" : "polypeptide region",
      "id" : "PRINTS",
      "name" : "PRINTS compendium of protein fingerprints",
      "database" : "PRINTS compendium of protein fingerprints"
   },
   "cgen" : {
      "database" : "Compugen Gene Ontology Gene Association Data",
      "id" : "CGEN",
      "object" : "entity",
      "url_example" : null,
      "name" : "Compugen Gene Ontology Gene Association Data",
      "example_id" : "CGEN:PrID131022",
      "abbreviation" : "CGEN",
      "url_syntax" : null,
      "uri_prefix" : null,
      "generic_url" : "http://www.cgen.com/",
      "datatype" : "entity",
      "fullname" : null
   },
   "embl" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.ebi.ac.uk/embl/",
      "datatype" : "gene",
      "fullname" : "International nucleotide sequence database collaboration, comprising EMBL-EBI nucleotide sequence data library (EMBL-Bank), DNA DataBank of Japan (DDBJ), and NCBI GenBank",
      "abbreviation" : "EMBL",
      "example_id" : "EMBL:AA816246",
      "url_syntax" : "http://www.ebi.ac.uk/cgi-bin/emblfetch?style=html&Submit=Go&id=[example_id]",
      "name" : "EMBL Nucleotide Sequence Database",
      "id" : "EMBL",
      "url_example" : "http://www.ebi.ac.uk/cgi-bin/emblfetch?style=html&Submit=Go&id=AA816246",
      "object" : "gene",
      "database" : "EMBL Nucleotide Sequence Database"
   },
   "unigene" : {
      "name" : "UniGene",
      "object" : "entity",
      "url_example" : "http://www.ncbi.nlm.nih.gov/UniGene/clust.cgi?ORG=Hs&CID=212293",
      "id" : "UniGene",
      "database" : "UniGene",
      "fullname" : "NCBI transcript cluster database, organized by transcriptome. Each UniGene entry is a set of transcript sequences that appear to come from the same transcription locus (gene or expressed pseudogene).",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/UniGene",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/UniGene/clust.cgi?ORG=[organism_abbreviation]&CID=[cluster_id]",
      "example_id" : "UniGene:Hs.212293",
      "abbreviation" : "UniGene"
   },
   "irgc" : {
      "database" : "International Rice Genebank Collection",
      "name" : "International Rice Genebank Collection",
      "object" : "entity",
      "url_example" : "https://www.genesys-pgr.org/acn/search?q=IRGC+10013",
      "id" : "IRGC",
      "generic_url" : "https://www.genesys-pgr.org",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "https://www.genesys-pgr.org/acn/search?q=IRGC+[example_id]",
      "abbreviation" : "IRGC",
      "example_id" : "IRGC:10012"
   },
   "pinc" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.proteome.com/",
      "fullname" : "represents GO annotations created in 2001 for NCBI and extracted into UniProtKB-GOA from EntrezGene",
      "datatype" : "entity",
      "example_id" : null,
      "abbreviation" : "PINC",
      "url_syntax" : null,
      "name" : "Proteome Inc.",
      "id" : "PINC",
      "object" : "entity",
      "url_example" : null,
      "database" : "Proteome Inc."
   },
   "coriell" : {
      "url_syntax" : "http://ccr.coriell.org/Sections/Search/Sample_Detail.aspx?Ref=[example_id]",
      "example_id" : "GM07892",
      "abbreviation" : "CORIELL",
      "fullname" : "The Coriell Cell Repositories provide essential research reagents to the scientific community by establishing, verifying, maintaining, and distributing cell cultures and DNA derived from cell cultures. These collections, supported by funds from the National Institutes of Health (NIH) and several foundations, are extensively utilized by research scientists around the world.",
      "generic_url" : "http://ccr.coriell.org/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "Coriell Institute for Medical Research",
      "url_example" : "http://ccr.coriell.org/Sections/Search/Sample_Detail.aspx?Ref=GM07892",
      "object" : "entity",
      "id" : "CORIELL",
      "name" : "Coriell Institute for Medical Research"
   },
   "genbank" : {
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?db=nucleotide&val=[example_id]",
      "abbreviation" : "GenBank",
      "example_id" : "GB:AA816246",
      "fullname" : "The NIH genetic sequence database, an annotated collection of all publicly available DNA sequences.",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/Genbank/",
      "datatype" : "protein",
      "uri_prefix" : null,
      "object" : "protein",
      "url_example" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?db=nucleotide&val=AA816246",
      "id" : "GenBank",
      "name" : "GenBank",
      "database" : "GenBank"
   },
   "lis" : {
      "database" : "Legume Information System",
      "name" : "Legume Information System",
      "object" : "entity",
      "url_example" : "http://legumeinfo.org/feature/Medicago/truncatula/gene/Medtr5g030920.JCVIMt4.0v1",
      "id" : "LIS",
      "datatype" : "entity",
      "generic_url" : "http://legumeinfo.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://legumeinfo.org/feature/Medicago/truncatula/gene/[example_id].JCVIMt4.0v1",
      "abbreviation" : "LIS",
      "example_id" : "LIS:Medtr5g030920"
   },
   "vida" : {
      "database" : "Virus Database at University College London",
      "name" : "Virus Database at University College London",
      "object" : "entity",
      "url_example" : null,
      "id" : "VIDA",
      "generic_url" : "http://www.biochem.ucl.ac.uk/bsm/virus_database/VIDA.html",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "VIDA"
   },
   "corum" : {
      "database" : "CORUM - the Comprehensive Resource of Mammalian protein complexes",
      "name" : "CORUM - the Comprehensive Resource of Mammalian protein complexes",
      "object" : "entity",
      "url_example" : "http://mips.gsf.de/genre/proj/corum/complexdetails.html?id=837",
      "id" : "CORUM",
      "datatype" : "entity",
      "generic_url" : "http://mips.gsf.de/genre/proj/corum/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://mips.gsf.de/genre/proj/corum/complexdetails.html?id=[example_id]",
      "abbreviation" : "CORUM",
      "example_id" : "CORUM:837"
   },
   "hgnc_gene" : {
      "url_syntax" : "http://www.genenames.org/data/hgnc_data.php?app_sym=[example_id]",
      "example_id" : "HGNC_gene:ABCA1",
      "abbreviation" : "HGNC_gene",
      "fullname" : null,
      "generic_url" : "http://www.genenames.org/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "HUGO Gene Nomenclature Committee",
      "object" : "entity",
      "url_example" : "http://www.genenames.org/data/hgnc_data.php?app_sym=ABCA1",
      "id" : "HGNC_gene",
      "name" : "HUGO Gene Nomenclature Committee"
   },
   "tigr_egad" : {
      "name" : "EGAD database at the J. Craig Venter Institute",
      "object" : "protein",
      "url_example" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenePage.cgi?locus=VCA0557",
      "id" : "JCVI_CMR",
      "database" : "EGAD database at the J. Craig Venter Institute",
      "datatype" : "protein",
      "generic_url" : "http://cmr.jcvi.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenePage.cgi?locus=[example_id]",
      "abbreviation" : "TIGR_EGAD",
      "example_id" : "JCVI_CMR:VCA0557"
   },
   "sgdid" : {
      "database" : "Saccharomyces Genome Database",
      "id" : "SGD",
      "object" : "gene",
      "url_example" : "http://www.yeastgenome.org/locus/S000006169/overview",
      "name" : "Saccharomyces Genome Database",
      "abbreviation" : "SGDID",
      "example_id" : "SGD:S000006169",
      "url_syntax" : "http://www.yeastgenome.org/locus/[example_id]/overview",
      "uri_prefix" : null,
      "generic_url" : "http://www.yeastgenome.org/",
      "datatype" : "gene",
      "fullname" : null
   },
   "apweb" : {
      "url_syntax" : "http://www.mobot.org/mobot/research/apweb/top/glossarya_h.html",
      "example_id" : "APweb:Glossary",
      "abbreviation" : "APweb",
      "fullname" : null,
      "generic_url" : "http://www.mobot.org/mobot/research/apweb/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_example" : "http://www.mobot.org/mobot/research/apweb/top/glossarya_h.html",
      "object" : "entity",
      "id" : "APweb",
      "name" : "Angiosperm Phylogeny Website",
      "database" : "Angiosperm Phylogeny Website"
   },
   "mi" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://psidev.sourceforge.net/mi/xml/doc/user/index.html",
      "datatype" : "entity",
      "example_id" : "MI:0018",
      "abbreviation" : "MI",
      "url_syntax" : null,
      "database" : "Proteomic Standard Initiative for Molecular Interaction",
      "name" : "Proteomic Standard Initiative for Molecular Interaction",
      "id" : "PSI-MI",
      "url_example" : null,
      "object" : "entity"
   },
   "h-invdb_cdna" : {
      "example_id" : "H-invDB_cDNA:AK093148",
      "abbreviation" : "H-invDB_cDNA",
      "url_syntax" : "http://www.h-invitational.jp/hinv/spsoup/transcript_view?acc_id=[example_id]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.h-invitational.jp/",
      "fullname" : null,
      "id" : "H-invDB_cDNA",
      "url_example" : "http://www.h-invitational.jp/hinv/spsoup/transcript_view?acc_id=AK093149",
      "object" : "entity",
      "name" : "H-invitational Database",
      "database" : "H-invitational Database"
   },
   "mgi" : {
      "database" : "Mouse Genome Informatics",
      "id" : "MGI",
      "object" : "variation",
      "url_example" : "http://www.informatics.jax.org/accession/MGI:80863",
      "name" : "Mouse Genome Informatics",
      "example_id" : "MGI:MGI:80863",
      "abbreviation" : "MGI",
      "url_syntax" : "http://www.informatics.jax.org/accession/[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.informatics.jax.org/",
      "datatype" : "variation"
   },
   "pompep" : {
      "database" : "Schizosaccharomyces pombe protein data",
      "name" : "Schizosaccharomyces pombe protein data",
      "id" : "Pompep",
      "object" : "entity",
      "url_example" : null,
      "uri_prefix" : null,
      "generic_url" : "ftp://ftp.sanger.ac.uk/pub/yeast/pombe/Protein_data/",
      "fullname" : null,
      "datatype" : "entity",
      "abbreviation" : "Pompep",
      "example_id" : "Pompep:SPAC890.04C",
      "url_syntax" : null
   },
   "eo_git" : {
      "uri_prefix" : null,
      "generic_url" : "https://github.com/Planteome/plant-environment-ontology",
      "fullname" : null,
      "datatype" : "entity",
      "abbreviation" : "EO_GIT",
      "example_id" : "EO_GIT:76",
      "url_syntax" : "https://github.com/Planteome/plant-environment-ontology/issues/[example_id]",
      "database" : "GitHub Issue Tracker for EO",
      "name" : "GitHub Issue Tracker for EO",
      "id" : "EO_GIT",
      "url_example" : "https://github.com/Planteome/plant-environment-ontology/issues/76",
      "object" : "entity"
   },
   "gr_mut" : {
      "datatype" : "entity",
      "generic_url" : "http://www.gramene.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.gramene.org/db/genes/search_gene?acc=[example_id]",
      "abbreviation" : "GR_MUT",
      "example_id" : "GR_MUT:GR:0060198",
      "name" : "A Comparative Mapping Resource for Grains",
      "url_example" : "http://www.gramene.org/db/genes/search_gene?acc=GR:0060198",
      "object" : "entity",
      "id" : "GR_MUT",
      "database" : "A Comparative Mapping Resource for Grains"
   },
   "ensembl_proteinid" : {
      "fullname" : null,
      "generic_url" : "http://www.ensembl.org/",
      "datatype" : "protein",
      "uri_prefix" : null,
      "url_syntax" : "http://www.ensembl.org/id/[example_id]",
      "abbreviation" : "ENSEMBL_ProteinID",
      "example_id" : "ENSEMBL_ProteinID:ENSP00000361027",
      "database" : "Ensembl database of automatically annotated genomic data",
      "name" : "Ensembl database of automatically annotated genomic data",
      "url_example" : "http://www.ensembl.org/id/ENSP00000361027",
      "object" : "protein",
      "id" : "ENSEMBL_ProteinID"
   },
   "go" : {
      "database" : "Gene Ontology Database",
      "name" : "Gene Ontology Database",
      "object" : "macromolecular complex",
      "url_example" : "http://amigo.geneontology.org/amigo/term/GO:0004352",
      "id" : "GO",
      "generic_url" : "http://amigo.geneontology.org/",
      "fullname" : null,
      "datatype" : "macromolecular complex",
      "uri_prefix" : null,
      "url_syntax" : "http://amigo.geneontology.org/amigo/term/GO:[example_id]",
      "example_id" : "GO:0004352",
      "abbreviation" : "GO"
   },
   "transfac" : {
      "url_syntax" : null,
      "abbreviation" : "TRANSFAC",
      "example_id" : null,
      "generic_url" : "http://www.gene-regulation.com/pub/databases.html#transfac",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "TRANSFAC database of eukaryotic transcription factors",
      "object" : "entity",
      "url_example" : null,
      "id" : "TRANSFAC",
      "name" : "TRANSFAC database of eukaryotic transcription factors"
   },
   "img" : {
      "url_syntax" : "http://img.jgi.doe.gov/cgi-bin/pub/main.cgi?section=GeneDetail&page=geneDetail&gene_oid=[example_id]",
      "abbreviation" : "IMG",
      "example_id" : "IMG:640008772",
      "generic_url" : "http://img.jgi.doe.gov",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "database" : "Integrated Microbial Genomes; JGI web site for genome annotation",
      "object" : "entity",
      "url_example" : "http://img.jgi.doe.gov/cgi-bin/pub/main.cgi?section=GeneDetail&page=geneDetail&gene_oid=640008772",
      "id" : "IMG",
      "name" : "Integrated Microbial Genomes; JGI web site for genome annotation"
   },
   "planteome_gene" : {
      "generic_url" : "http://www.google.com",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "https://www.google.com/search?q=[example_id]",
      "example_id" : "Planteome_gene:AC148152.3_FGT008",
      "abbreviation" : "Planteome_gene",
      "name" : "Generic planteome genes without homes",
      "object" : "entity",
      "url_example" : "https://www.google.com/search?q=AC148152.3_FGT008",
      "id" : "Planteome_gene",
      "database" : "Generic planteome genes without homes"
   },
   "superfamily" : {
      "database" : "SUPERFAMILY protein annotation database",
      "name" : "SUPERFAMILY protein annotation database",
      "id" : "SUPERFAMILY",
      "object" : "entity",
      "url_example" : "http://supfam.cs.bris.ac.uk/SUPERFAMILY/cgi-bin/scop.cgi?ipid=SSF51905",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://supfam.cs.bris.ac.uk/SUPERFAMILY/index.html",
      "fullname" : "A database of structural and functional protein annotations for completely sequenced genomes",
      "example_id" : "SUPERFAMILY:51905",
      "abbreviation" : "SUPERFAMILY",
      "url_syntax" : "http://supfam.cs.bris.ac.uk/SUPERFAMILY/cgi-bin/scop.cgi?ipid=SSF[example_id]"
   },
   "cog_function" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/COG/",
      "datatype" : "entity",
      "fullname" : null,
      "abbreviation" : "COG_Function",
      "example_id" : "COG_Function:H",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/COG/grace/shokog.cgi?fun=[example_id]",
      "name" : "NCBI COG function",
      "id" : "COG_Function",
      "url_example" : "http://www.ncbi.nlm.nih.gov/COG/grace/shokog.cgi?fun=H",
      "object" : "entity",
      "database" : "NCBI COG function"
   },
   "jcvi_cmr" : {
      "database" : "EGAD database at the J. Craig Venter Institute",
      "object" : "protein",
      "url_example" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenePage.cgi?locus=VCA0557",
      "id" : "JCVI_CMR",
      "name" : "EGAD database at the J. Craig Venter Institute",
      "url_syntax" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenePage.cgi?locus=[example_id]",
      "example_id" : "JCVI_CMR:VCA0557",
      "abbreviation" : "JCVI_CMR",
      "fullname" : null,
      "generic_url" : "http://cmr.jcvi.org/",
      "datatype" : "protein",
      "uri_prefix" : null
   },
   "tc" : {
      "database" : "Transport Protein Database",
      "name" : "Transport Protein Database",
      "url_example" : "http://www.tcdb.org/tcdb/index.php?tc=9.A.4.1.1",
      "object" : "protein",
      "id" : "TC",
      "generic_url" : "http://www.tcdb.org/",
      "datatype" : "protein",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.tcdb.org/tcdb/index.php?tc=[example_id]",
      "example_id" : "TC:9.A.4.1.1",
      "abbreviation" : "TC"
   },
   "mesh" : {
      "object" : "entity",
      "url_example" : "http://n2t.net/MESH:D017209",
      "id" : "MeSH",
      "name" : "Medical Subject Headings",
      "database" : "Medical Subject Headings",
      "url_syntax" : "http://n2t.net/MESH:[example_id]",
      "abbreviation" : "MESH",
      "example_id" : "MeSH:D017209",
      "datatype" : "entity",
      "generic_url" : "https://www.nlm.nih.gov/mesh/MBrowser.html",
      "fullname" : null,
      "uri_prefix" : null
   },
   "biomd" : {
      "fullname" : null,
      "generic_url" : "http://www.ebi.ac.uk/biomodels/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://www.ebi.ac.uk/compneur-srv/biomodels-main/publ-model.do?mid=[example_id]",
      "abbreviation" : "BIOMD",
      "example_id" : "BIOMD:BIOMD0000000045",
      "name" : "BioModels Database",
      "url_example" : "http://www.ebi.ac.uk/compneur-srv/biomodels-main/publ-model.do?mid=BIOMD0000000045",
      "object" : "entity",
      "id" : "BIOMD",
      "database" : "BioModels Database"
   },
   "tair" : {
      "uri_prefix" : null,
      "datatype" : "communication",
      "generic_url" : "http://www.arabidopsis.org/",
      "fullname" : null,
      "abbreviation" : "TAIR",
      "example_id" : "TAIR:Communication:1345790",
      "url_syntax" : "http://arabidopsis.org/servlets/TairObject?type=communication&id=[example_id]",
      "name" : "The Arabidopsis Information Resource",
      "id" : "TAIR",
      "url_example" : "http://arabidopsis.org/servlets/TairObject?type=communication&id=1345790",
      "object" : "communication",
      "database" : "The Arabidopsis Information Resource"
   },
   "tr" : {
      "database" : "TREMBL",
      "name" : "TREMBL",
      "id" : "TR",
      "object" : "entity",
      "url_example" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:Q00177]",
      "uri_prefix" : null,
      "generic_url" : "http://www.ebi.ac.uk/swissprot/",
      "datatype" : "entity",
      "fullname" : null,
      "example_id" : "TrEMBL:Q00177",
      "abbreviation" : "TR",
      "url_syntax" : "http://srs.ebi.ac.uk/srs6bin/cgi-bin/wgetz?-e+[SWALL-acc:[example_id]]"
   },
   "ensemblmetazoa" : {
      "database" : "Ensembl Metazoa, the Ensembl database for accessing genome-scale data from non-vertebrate metazoa.",
      "name" : "Ensembl Metazoa, the Ensembl database for accessing genome-scale data from non-vertebrate metazoa.",
      "id" : "EnsemblMetazoa",
      "url_example" : "http://www.ensemblgenomes.org/id/FBgn0052693",
      "object" : "gene",
      "uri_prefix" : null,
      "generic_url" : "http://metazoa.ensembl.org/",
      "datatype" : "gene",
      "fullname" : null,
      "abbreviation" : "EnsemblMetazoa",
      "example_id" : "EnsemblMetazoa:FBgn0052693",
      "url_syntax" : "http://www.ensemblgenomes.org/id/[example_id]"
   },
   "broad_mgg" : {
      "example_id" : "Broad_MGG:MGG_05132.5",
      "abbreviation" : "Broad_MGG",
      "url_syntax" : "http://www.broad.mit.edu/annotation/genome/magnaporthe_grisea/GeneLocus.html?sp=S[example_id]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.broad.mit.edu/annotation/genome/magnaporthe_grisea/Home.html",
      "fullname" : "Magnaporthe grisea Database at the Broad Institute",
      "id" : "Broad_MGG",
      "object" : "entity",
      "url_example" : "http://www.broad.mit.edu/annotation/genome/magnaporthe_grisea/GeneLocus.html?sp=SMGG_05132",
      "name" : "Magnaporthe grisea Database",
      "database" : "Magnaporthe grisea Database"
   },
   "syngo" : {
      "id" : "SynGO",
      "url_example" : null,
      "object" : "entity",
      "name" : "The Synapse Gene Ontology and Annotation Initiative",
      "database" : "The Synapse Gene Ontology and Annotation Initiative",
      "abbreviation" : "SynGO",
      "example_id" : null,
      "url_syntax" : null,
      "uri_prefix" : null,
      "generic_url" : "http://geneontology.org/page/syngo-synapse-biology",
      "datatype" : "entity",
      "fullname" : null
   },
   "hgnc" : {
      "url_syntax" : "http://www.genenames.org/data/hgnc_data.php?hgnc_id=HGNC:[example_id]",
      "abbreviation" : "HGNC",
      "example_id" : "HGNC:29",
      "fullname" : null,
      "generic_url" : "http://www.genenames.org/",
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_example" : "http://www.genenames.org/data/hgnc_data.php?hgnc_id=HGNC:29",
      "object" : "gene",
      "id" : "HGNC",
      "name" : "HUGO Gene Nomenclature Committee",
      "database" : "HUGO Gene Nomenclature Committee"
   },
   "obo_sf_po" : {
      "url_syntax" : "https://sourceforge.net/tracker/index.php?func=detail&aid=[example_id]&group_id=76834&atid=835555",
      "abbreviation" : "OBO_SF_PO",
      "example_id" : "OBO_SF_PO:3184921",
      "generic_url" : "http://sourceforge.net/tracker/?func=browse&group_id=76834&atid=835555",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "Source Forge OBO Plant Ontology (PO) term request tracker",
      "object" : "entity",
      "url_example" : "https://sourceforge.net/tracker/index.php?func=detail&aid=3184921&group_id=76834&atid=835555",
      "id" : "OBO_SF_PO",
      "name" : "Source Forge OBO Plant Ontology (PO) term request tracker"
   },
   "genprotec" : {
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://genprotec.mbl.edu/",
      "fullname" : null,
      "abbreviation" : "GenProtEC",
      "example_id" : null,
      "url_syntax" : null,
      "database" : "GenProtEC E. coli genome and proteome database",
      "name" : "GenProtEC E. coli genome and proteome database",
      "id" : "GenProtEC",
      "url_example" : null,
      "object" : "entity"
   },
   "ptarget" : {
      "name" : "pTARGET Prediction server for protein subcellular localization",
      "object" : "entity",
      "url_example" : null,
      "id" : "pTARGET",
      "database" : "pTARGET Prediction server for protein subcellular localization",
      "generic_url" : "http://bioinformatics.albany.edu/~ptarget/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "pTARGET"
   },
   "merops" : {
      "id" : "MEROPS",
      "object" : "protein",
      "url_example" : "http://merops.sanger.ac.uk/cgi-bin/pepsum?mid=A08.001",
      "name" : "MEROPS peptidase database",
      "database" : "MEROPS peptidase database",
      "example_id" : "MEROPS:A08.001",
      "abbreviation" : "MEROPS",
      "url_syntax" : "http://merops.sanger.ac.uk/cgi-bin/pepsum?mid=[example_id]",
      "uri_prefix" : null,
      "datatype" : "protein",
      "generic_url" : "http://merops.sanger.ac.uk/",
      "fullname" : null
   },
   "sabio-rk" : {
      "generic_url" : "http://sabio.villa-bosch.de/",
      "fullname" : "The SABIO-RK (System for the Analysis of Biochemical Pathways - Reaction Kinetics) is a web-based application based on the SABIO relational database that contains information about biochemical reactions, their kinetic equations with their parameters, and the experimental conditions under which these parameters were measured.",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://sabio.villa-bosch.de/reacdetails.jsp?reactid=[example_id]",
      "abbreviation" : "SABIO-RK",
      "example_id" : "SABIO-RK:1858",
      "name" : "SABIO Reaction Kinetics",
      "object" : "entity",
      "url_example" : "http://sabio.villa-bosch.de/reacdetails.jsp?reactid=1858",
      "id" : "SABIO-RK",
      "database" : "SABIO Reaction Kinetics"
   },
   "iric" : {
      "url_syntax" : "http://oryzasnp.org/_variety.zul?irisid=[example_id]",
      "example_id" : "IRIS_313-8922",
      "abbreviation" : "IRIC",
      "generic_url" : "http://oryzasnp.org",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "International Rice Research Institute",
      "object" : "entity",
      "url_example" : "http://oryzasnp.org/_variety.zul?irisid=IRIS_313-8922",
      "id" : "IRIC",
      "name" : "International Rice Research Institute"
   },
   "gb" : {
      "name" : "GenBank",
      "id" : "GenBank",
      "url_example" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?db=nucleotide&val=AA816246",
      "object" : "protein",
      "database" : "GenBank",
      "uri_prefix" : null,
      "datatype" : "protein",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/Genbank/",
      "fullname" : "The NIH genetic sequence database, an annotated collection of all publicly available DNA sequences.",
      "abbreviation" : "GB",
      "example_id" : "GB:AA816246",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?db=nucleotide&val=[example_id]"
   },
   "cgdid" : {
      "name" : "Candida Genome Database",
      "id" : "CGD",
      "object" : "gene",
      "url_example" : "http://www.candidagenome.org/cgi-bin/locus.pl?dbid=CAL0005516",
      "database" : "Candida Genome Database",
      "uri_prefix" : null,
      "generic_url" : "http://www.candidagenome.org/",
      "datatype" : "gene",
      "fullname" : null,
      "example_id" : "CGD:CAL0005516",
      "abbreviation" : "CGDID",
      "url_syntax" : "http://www.candidagenome.org/cgi-bin/locus.pl?dbid=[example_id]"
   },
   "jcvi_egad" : {
      "datatype" : "entity",
      "generic_url" : "http://cmr.jcvi.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://cmr.jcvi.org/cgi-bin/CMR/EgadSearch.cgi?search_string=[example_id]",
      "example_id" : "JCVI_EGAD:74462",
      "abbreviation" : "JCVI_EGAD",
      "database" : "JCVI CMR Egad",
      "name" : "JCVI CMR Egad",
      "url_example" : "http://cmr.jcvi.org/cgi-bin/CMR/EgadSearch.cgi?search_string=74462",
      "object" : "entity",
      "id" : "JCVI_EGAD"
   },
   "gr_protein" : {
      "uri_prefix" : null,
      "datatype" : "protein",
      "generic_url" : "http://www.gramene.org/",
      "fullname" : null,
      "abbreviation" : "GR_protein",
      "example_id" : "GR_PROTEIN:Q6VSV0",
      "url_syntax" : "http://www.gramene.org/db/protein/protein_search?acc=[example_id]",
      "database" : "Gramene",
      "name" : "Gramene",
      "id" : "GR_PROTEIN",
      "url_example" : "http://www.gramene.org/db/protein/protein_search?acc=Q6VSV0",
      "object" : "protein"
   },
   "genesys-pgr" : {
      "example_id" : "Genesys-pgr:CM1015-16",
      "abbreviation" : "Genesys-pgr",
      "url_syntax" : "https://www.genesys-pgr.org/acn/search?q=[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "https://www.genesys-pgr.org/",
      "datatype" : "entity",
      "database" : "Gene DB, Genesys",
      "id" : "Genesys-pgr",
      "object" : "entity",
      "url_example" : "https://www.genesys-pgr.org/acn/search?q=CM1015-16",
      "name" : "Gene DB, Genesys"
   },
   "tigr_tigrfams" : {
      "example_id" : "JCVI_TIGRFAMS:TIGR00254",
      "abbreviation" : "TIGR_TIGRFAMS",
      "url_syntax" : "http://search.jcvi.org/search?p&q=[example_id]",
      "uri_prefix" : null,
      "datatype" : "polypeptide region",
      "generic_url" : "http://search.jcvi.org/",
      "fullname" : null,
      "id" : "JCVI_TIGRFAMS",
      "url_example" : "http://search.jcvi.org/search?p&q=TIGR00254",
      "object" : "polypeptide region",
      "name" : "TIGRFAMs HMM collection at the J. Craig Venter Institute",
      "database" : "TIGRFAMs HMM collection at the J. Craig Venter Institute"
   },
   "muscletrait" : {
      "generic_url" : "http://muscle.cribi.unipd.it/",
      "datatype" : "entity",
      "fullname" : "an integrated database of transcripts expressed in human skeletal muscle",
      "uri_prefix" : null,
      "url_syntax" : null,
      "abbreviation" : "MuscleTRAIT",
      "example_id" : null,
      "name" : "TRAnscript Integrated Table",
      "url_example" : null,
      "object" : "entity",
      "id" : "TRAIT",
      "database" : "TRAnscript Integrated Table"
   },
   "merops_fam" : {
      "url_syntax" : "http://merops.sanger.ac.uk/cgi-bin/famsum?family=[example_id]",
      "example_id" : "MEROPS_fam:M18",
      "abbreviation" : "MEROPS_fam",
      "datatype" : "entity",
      "generic_url" : "http://merops.sanger.ac.uk/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_example" : "http://merops.sanger.ac.uk/cgi-bin/famsum?family=m18",
      "object" : "entity",
      "id" : "MEROPS_fam",
      "name" : "MEROPS peptidase database",
      "database" : "MEROPS peptidase database"
   },
   "ecoliwiki" : {
      "database" : "EcoliWiki from EcoliHub",
      "name" : "EcoliWiki from EcoliHub",
      "object" : "gene",
      "url_example" : null,
      "id" : "EcoliWiki",
      "generic_url" : "http://ecoliwiki.net/",
      "fullname" : "EcoliHub\\'s subsystem for community annotation of E. coli K-12",
      "datatype" : "gene",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "EcoliWiki"
   },
   "jstor" : {
      "database" : "Digital archive of scholarly articles",
      "object" : "entity",
      "url_example" : "http://www.jstor.org/stable/3093870",
      "id" : "JSTOR",
      "name" : "Digital archive of scholarly articles",
      "url_syntax" : "http://www.jstor.org/stable/[example_id]",
      "example_id" : "JSTOR:3093870",
      "abbreviation" : "JSTOR",
      "generic_url" : "http://www.jstor.org/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "dictybase_gene_name" : {
      "object" : "entity",
      "url_example" : "http://dictybase.org/gene/mlcE",
      "id" : "dictyBase_gene_name",
      "name" : "dictyBase",
      "database" : "dictyBase",
      "url_syntax" : "http://dictybase.org/gene/[example_id]",
      "abbreviation" : "dictyBase_gene_name",
      "example_id" : "dictyBase_gene_name:mlcE",
      "datatype" : "entity",
      "generic_url" : "http://dictybase.org",
      "fullname" : null,
      "uri_prefix" : null
   },
   "iuphar_receptor" : {
      "generic_url" : "http://www.iuphar.org/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.iuphar-db.org/DATABASE/ObjectDisplayForward?objectId=[example_id]",
      "example_id" : "IUPHAR_RECEPTOR:2205",
      "abbreviation" : "IUPHAR_RECEPTOR",
      "database" : "International Union of Pharmacology",
      "name" : "International Union of Pharmacology",
      "object" : "entity",
      "url_example" : "http://www.iuphar-db.org/DATABASE/ObjectDisplayForward?objectId=56",
      "id" : "IUPHAR_RECEPTOR"
   },
   "ddbj" : {
      "example_id" : "DDBJ:AA816246",
      "abbreviation" : "DDBJ",
      "url_syntax" : "http://arsa.ddbj.nig.ac.jp/arsa/ddbjSplSearch?KeyWord=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.ddbj.nig.ac.jp/",
      "fullname" : null,
      "datatype" : "entity",
      "id" : "DDBJ",
      "object" : "entity",
      "url_example" : "http://arsa.ddbj.nig.ac.jp/arsa/ddbjSplSearch?KeyWord=AA816246",
      "name" : "DNA Databank of Japan",
      "database" : "DNA Databank of Japan"
   },
   "pfam" : {
      "datatype" : "polypeptide region",
      "generic_url" : "http://pfam.xfam.org",
      "fullname" : "Pfam is a collection of protein families represented by sequence alignments and hidden Markov models (HMMs)",
      "uri_prefix" : null,
      "url_syntax" : "http://pfam.xfam.org/family/[example_id]",
      "example_id" : "Pfam:PF00046",
      "abbreviation" : "Pfam",
      "database" : "Pfam database of protein families",
      "name" : "Pfam database of protein families",
      "object" : "polypeptide region",
      "url_example" : "http://pfam.xfam.org/family/PF00069",
      "id" : "Pfam"
   },
   "gorel" : {
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "GOREL",
      "generic_url" : "http://purl.obolibrary.org/obo/ro",
      "datatype" : "entity",
      "fullname" : "Additional relations pending addition into RO",
      "uri_prefix" : null,
      "database" : "GO Extensions to OBO Relation Ontology Ontology",
      "object" : "entity",
      "url_example" : null,
      "id" : "GOREL",
      "name" : "GO Extensions to OBO Relation Ontology Ontology"
   },
   "ma" : {
      "name" : "Adult Mouse Anatomical Dictionary",
      "object" : "entity",
      "url_example" : "http://www.informatics.jax.org/searches/AMA.cgi?id=MA:0000003",
      "id" : "MA",
      "database" : "Adult Mouse Anatomical Dictionary",
      "datatype" : "entity",
      "generic_url" : "http://www.informatics.jax.org/",
      "fullname" : "Adult Mouse Anatomical Dictionary; part of Gene Expression Database",
      "uri_prefix" : null,
      "url_syntax" : "http://www.informatics.jax.org/searches/AMA.cgi?id=MA:[example_id]",
      "abbreviation" : "MA",
      "example_id" : "MA:0000003"
   },
   "kegg_pathway" : {
      "database" : "KEGG Pathways Database",
      "id" : "KEGG_PATHWAY",
      "url_example" : "http://www.genome.jp/dbget-bin/www_bget?path:ot00020",
      "object" : "entity",
      "name" : "KEGG Pathways Database",
      "abbreviation" : "KEGG_PATHWAY",
      "example_id" : "KEGG_PATHWAY:ot00020",
      "url_syntax" : "http://www.genome.jp/dbget-bin/www_bget?path:[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.genome.jp/kegg/pathway.html",
      "fullname" : null,
      "datatype" : "entity"
   },
   "sgd_ref" : {
      "url_syntax" : "http://www.yeastgenome.org/reference/[example_id]/overview",
      "abbreviation" : "SGD_REF",
      "example_id" : "SGD_REF:S000049602",
      "generic_url" : "http://www.yeastgenome.org/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "database" : "Saccharomyces Genome Database",
      "object" : "entity",
      "url_example" : "http://www.yeastgenome.org/reference/S000049602/overview",
      "id" : "SGD_REF",
      "name" : "Saccharomyces Genome Database"
   },
   "aruk-ucl" : {
      "database" : "Alzheimers Research Gene Ontology Initiative",
      "name" : "Alzheimers Research Gene Ontology Initiative",
      "url_example" : null,
      "object" : "entity",
      "id" : "ARUK-UCL",
      "generic_url" : "http://www.ucl.ac.uk/functional-gene-annotation/neurological",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "ARUK-UCL"
   },
   "rnamdb" : {
      "url_syntax" : "http://s59.cas.albany.edu/RNAmods/cgi-bin/rnashow.cgi?[example_id]",
      "abbreviation" : "RNAMDB",
      "example_id" : "RNAmods:037",
      "fullname" : null,
      "generic_url" : "http://s59.cas.albany.edu/RNAmods/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "object" : "entity",
      "url_example" : "http://s59.cas.albany.edu/RNAmods/cgi-bin/rnashow.cgi?091",
      "id" : "RNAmods",
      "name" : "RNA Modification Database",
      "database" : "RNA Modification Database"
   },
   "msh" : {
      "url_syntax" : "http://n2t.net/MESH:[example_id]",
      "example_id" : "MeSH:D017209",
      "abbreviation" : "MSH",
      "fullname" : null,
      "generic_url" : "https://www.nlm.nih.gov/mesh/MBrowser.html",
      "datatype" : "entity",
      "uri_prefix" : null,
      "object" : "entity",
      "url_example" : "http://n2t.net/MESH:D017209",
      "id" : "MeSH",
      "name" : "Medical Subject Headings",
      "database" : "Medical Subject Headings"
   },
   "jcvi" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.jcvi.org/",
      "fullname" : null,
      "datatype" : "entity",
      "abbreviation" : "JCVI",
      "example_id" : null,
      "url_syntax" : null,
      "database" : "J. Craig Venter Institute",
      "name" : "J. Craig Venter Institute",
      "id" : "JCVI",
      "object" : "entity",
      "url_example" : null
   },
   "phi" : {
      "fullname" : null,
      "generic_url" : "http://aclame.ulb.ac.be/Classification/mego.html",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : null,
      "example_id" : "PHI:0000055",
      "abbreviation" : "PHI",
      "name" : "MeGO (Phage and Mobile Element Ontology)",
      "url_example" : null,
      "object" : "entity",
      "id" : "PHI",
      "database" : "MeGO (Phage and Mobile Element Ontology)"
   },
   "pubmed" : {
      "database" : "PubMed",
      "name" : "PubMed",
      "object" : "entity",
      "url_example" : "http://www.ncbi.nlm.nih.gov/pubmed/4208797",
      "id" : "PMID",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/PubMed/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/pubmed/[example_id]",
      "abbreviation" : "PubMed",
      "example_id" : "PMID:4208797"
   },
   "gonuts" : {
      "database" : "Gene Ontology Normal Usage Tracking System (GONUTS)",
      "id" : "GONUTS",
      "object" : "entity",
      "url_example" : "http://gowiki.tamu.edu/wiki/index.php/MOUSE:CD28",
      "name" : "Gene Ontology Normal Usage Tracking System (GONUTS)",
      "example_id" : "GONUTS:MOUSE:CD28",
      "abbreviation" : "GONUTS",
      "url_syntax" : "http://gowiki.tamu.edu/wiki/index.php/[example_id]",
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://gowiki.tamu.edu",
      "fullname" : "Third party documentation for GO and community annotation system."
   },
   "pamgo_gat" : {
      "name" : "Genome Annotation Tool (Agrobacterium tumefaciens C58); PAMGO Interest Group",
      "url_example" : "http://agro.vbi.vt.edu/public/servlet/GeneEdit?&Search=Search&level=2&genename=atu0001",
      "object" : "entity",
      "id" : "PAMGO_GAT",
      "database" : "Genome Annotation Tool (Agrobacterium tumefaciens C58); PAMGO Interest Group",
      "fullname" : null,
      "generic_url" : "http://agro.vbi.vt.edu/public/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://agro.vbi.vt.edu/public/servlet/GeneEdit?&Search=Search&level=2&genename=[example_id]",
      "abbreviation" : "PAMGO_GAT",
      "example_id" : "PAMGO_GAT:Atu0001"
   },
   "omssa" : {
      "abbreviation" : "OMSSA",
      "example_id" : null,
      "url_syntax" : null,
      "uri_prefix" : null,
      "generic_url" : "http://pubchem.ncbi.nlm.nih.gov/omssa/",
      "datatype" : "entity",
      "fullname" : null,
      "database" : "Open Mass Spectrometry Search Algorithm",
      "id" : "OMSSA",
      "url_example" : null,
      "object" : "entity",
      "name" : "Open Mass Spectrometry Search Algorithm"
   },
   "doi" : {
      "database" : "Digital Object Identifier",
      "id" : "DOI",
      "url_example" : "http://dx.doi.org/10.1016/S0963-9969(99)00021-6",
      "object" : "entity",
      "name" : "Digital Object Identifier",
      "abbreviation" : "DOI",
      "example_id" : "DOI:10.1016/S0963-9969(99)00021-6",
      "url_syntax" : "http://dx.doi.org/[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://dx.doi.org/",
      "fullname" : null,
      "datatype" : "entity"
   },
   "spd" : {
      "datatype" : "entity",
      "generic_url" : "http://www.riken.jp/SPD/",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.riken.jp/SPD/[example_id].html",
      "example_id" : "SPD:05/05F01",
      "abbreviation" : "SPD",
      "database" : "Schizosaccharomyces pombe Postgenome Database at RIKEN; includes Orfeome Localisation data",
      "name" : "Schizosaccharomyces pombe Postgenome Database at RIKEN; includes Orfeome Localisation data",
      "url_example" : "http://www.riken.jp/SPD/05/05F01.html",
      "object" : "entity",
      "id" : "SPD"
   },
   "dictybase_ref" : {
      "abbreviation" : "dictyBase_REF",
      "example_id" : "dictyBase_REF:10157",
      "url_syntax" : "http://dictybase.org/db/cgi-bin/dictyBase/reference/reference.pl?refNo=[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://dictybase.org",
      "datatype" : "entity",
      "id" : "dictyBase_REF",
      "object" : "entity",
      "url_example" : "http://dictybase.org/db/cgi-bin/dictyBase/reference/reference.pl?refNo=10157",
      "name" : "dictyBase literature references",
      "database" : "dictyBase literature references"
   },
   "prodom" : {
      "uri_prefix" : null,
      "fullname" : "ProDom protein domain families automatically generated from UniProtKB",
      "generic_url" : "http://prodom.prabi.fr/prodom/current/html/home.php",
      "datatype" : "entity",
      "example_id" : "ProDom:PD000001",
      "abbreviation" : "ProDom",
      "url_syntax" : "http://prodom.prabi.fr/prodom/current/cgi-bin/request.pl?question=DBEN&query=[example_id]",
      "database" : "ProDom protein domain families",
      "name" : "ProDom protein domain families",
      "id" : "ProDom",
      "object" : "entity",
      "url_example" : "http://prodom.prabi.fr/prodom/current/cgi-bin/request.pl?question=DBEN&query=PD000001"
   },
   "locsvmpsi" : {
      "url_syntax" : null,
      "abbreviation" : "LOCSVMpsi",
      "example_id" : null,
      "generic_url" : "http://bioinformatics.ustc.edu.cn/locsvmpsi/locsvmpsi.php",
      "datatype" : "entity",
      "fullname" : "Subcellular localization for eukayotic proteins based on SVM and PSI-BLAST",
      "uri_prefix" : null,
      "database" : "LOCSVMPSI",
      "object" : "entity",
      "url_example" : null,
      "id" : "LOCSVMpsi",
      "name" : "LOCSVMPSI"
   },
   "gr_ref" : {
      "generic_url" : "http://www.gramene.org/",
      "datatype" : "entity",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.gramene.org/db/literature/pub_search?ref_id=[example_id]",
      "example_id" : "GR_REF:659",
      "abbreviation" : "GR_REF",
      "database" : "Gramene",
      "name" : "Gramene",
      "object" : "entity",
      "url_example" : "http://www.gramene.org/db/literature/pub_search?ref_id=659",
      "id" : "GR_REF"
   },
   "rfam" : {
      "example_id" : "Rfam:RF00012",
      "abbreviation" : "Rfam",
      "url_syntax" : "http://rfam.sanger.ac.uk/family/[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://rfam.sanger.ac.uk/",
      "fullname" : null,
      "datatype" : "entity",
      "id" : "Rfam",
      "object" : "entity",
      "url_example" : "http://rfam.sanger.ac.uk/family/RF00012",
      "name" : "Rfam database of RNA families",
      "database" : "Rfam database of RNA families"
   },
   "goc" : {
      "url_syntax" : null,
      "example_id" : null,
      "abbreviation" : "GOC",
      "datatype" : "entity",
      "generic_url" : "http://www.geneontology.org/",
      "fullname" : null,
      "uri_prefix" : null,
      "database" : "Gene Ontology Consortium",
      "object" : "entity",
      "url_example" : null,
      "id" : "GOC",
      "name" : "Gene Ontology Consortium"
   },
   "cgd_ref" : {
      "database" : "Candida Genome Database",
      "name" : "Candida Genome Database",
      "id" : "CGD_REF",
      "object" : "entity",
      "url_example" : "http://www.candidagenome.org/cgi-bin/reference/reference.pl?dbid=1490",
      "uri_prefix" : null,
      "generic_url" : "http://www.candidagenome.org/",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "CGD_REF:1490",
      "abbreviation" : "CGD_REF",
      "url_syntax" : "http://www.candidagenome.org/cgi-bin/reference/reference.pl?dbid=[example_id]"
   },
   "eupathdb" : {
      "abbreviation" : "EuPathDB",
      "example_id" : "EuPathDB:LtaP17.1490",
      "url_syntax" : "http://eupathdb.org/gene/[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://eupathdb.org",
      "datatype" : "gene",
      "fullname" : null,
      "database" : "The Eukaryotic Pathogen Database",
      "id" : "EuPathDB",
      "url_example" : "http://eupathdb.org/gene/LtaP17.1490",
      "object" : "gene",
      "name" : "The Eukaryotic Pathogen Database"
   },
   "hugo" : {
      "example_id" : null,
      "abbreviation" : "HUGO",
      "url_syntax" : null,
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.hugo-international.org/",
      "fullname" : null,
      "id" : "HUGO",
      "url_example" : null,
      "object" : "entity",
      "name" : "Human Genome Organisation",
      "database" : "Human Genome Organisation"
   },
   "nmpdr" : {
      "name" : "National Microbial Pathogen Data Resource",
      "object" : "entity",
      "url_example" : "http://www.nmpdr.org/linkin.cgi?id=fig|306254.1.peg.183",
      "id" : "NMPDR",
      "database" : "National Microbial Pathogen Data Resource",
      "datatype" : "entity",
      "generic_url" : "http://www.nmpdr.org",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.nmpdr.org/linkin.cgi?id=[example_id]",
      "abbreviation" : "NMPDR",
      "example_id" : "NMPDR:fig|306254.1.peg.183"
   },
   "ensemblplants/gramene" : {
      "name" : "Ensembl Plants, the Ensembl database for accessing genome-scale data from plants.",
      "url_example" : "http://www.ensemblgenomes.org/id/LOC_Os01g22954",
      "object" : "gene",
      "id" : "EnsemblPlants",
      "database" : "Ensembl Plants, the Ensembl database for accessing genome-scale data from plants.",
      "generic_url" : "http://plants.ensembl.org/",
      "datatype" : "gene",
      "fullname" : null,
      "uri_prefix" : null,
      "url_syntax" : "http://www.ensemblgenomes.org/id/[example_id]",
      "example_id" : "EnsemblPlants:LOC_Os01g22954",
      "abbreviation" : "EnsemblPlants/Gramene"
   },
   "cgsc" : {
      "url_syntax" : null,
      "example_id" : "CGSC:rbsK",
      "abbreviation" : "CGSC",
      "datatype" : "entity",
      "generic_url" : "http://cgsc.biology.yale.edu/",
      "fullname" : null,
      "uri_prefix" : null,
      "object" : "entity",
      "url_example" : "http://cgsc.biology.yale.edu/Site.php?ID=315",
      "id" : "CGSC",
      "name" : "CGSC",
      "database" : "CGSC"
   },
   "peco_git" : {
      "url_example" : "https://github.com/Planteome/plant-experimental-conditions-ontology/issues/76",
      "object" : "entity",
      "id" : "PECO_GIT",
      "name" : "GitHub Issue Tracker for PECO",
      "database" : "GitHub Issue Tracker for PECO",
      "url_syntax" : "https://github.com/Planteome/plant-environment-ontology/issues/[example_id]",
      "example_id" : "PECO_GIT:76",
      "abbreviation" : "PECO_GIT",
      "datatype" : "entity",
      "generic_url" : "https://github.com/Planteome/plant-experimental-conditions-ontology",
      "fullname" : null,
      "uri_prefix" : null
   },
   "cas_gen" : {
      "uri_prefix" : null,
      "generic_url" : "http://research.calacademy.org/research/ichthyology/catalog/fishcatsearch.html",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "CASGEN:1040",
      "abbreviation" : "CAS_GEN",
      "url_syntax" : "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Genus&id=[example_id]",
      "name" : "Catalog of Fishes genus database",
      "id" : "CASGEN",
      "object" : "entity",
      "url_example" : "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Genus&id=1040",
      "database" : "Catalog of Fishes genus database"
   },
   "ddb" : {
      "uri_prefix" : null,
      "generic_url" : "http://dictybase.org",
      "datatype" : "gene",
      "fullname" : null,
      "example_id" : "dictyBase:DDB_G0277859",
      "abbreviation" : "DDB",
      "url_syntax" : "http://dictybase.org/gene/[example_id]",
      "name" : "dictyBase",
      "id" : "dictyBase",
      "url_example" : "http://dictybase.org/gene/DDB_G0277859",
      "object" : "gene",
      "database" : "dictyBase"
   },
   "iuphar_gpcr" : {
      "id" : "IUPHAR_GPCR",
      "object" : "entity",
      "url_example" : "http://www.iuphar-db.org/DATABASE/FamilyMenuForward?familyId=13",
      "name" : "International Union of Pharmacology",
      "database" : "International Union of Pharmacology",
      "example_id" : "IUPHAR_GPCR:1279",
      "abbreviation" : "IUPHAR_GPCR",
      "url_syntax" : "http://www.iuphar-db.org/DATABASE/FamilyMenuForward?familyId=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.iuphar.org/",
      "fullname" : null,
      "datatype" : "entity"
   },
   "ecogene_g" : {
      "database" : "EcoGene Database of Escherichia coli Sequence and Function",
      "name" : "EcoGene Database of Escherichia coli Sequence and Function",
      "id" : "ECOGENE_G",
      "url_example" : null,
      "object" : "entity",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.ecogene.org/",
      "datatype" : "entity",
      "abbreviation" : "ECOGENE_G",
      "example_id" : "ECOGENE_G:deoC",
      "url_syntax" : null
   },
   "pubchem_bioassay" : {
      "example_id" : "PubChem_BioAssay:177",
      "abbreviation" : "PubChem_BioAssay",
      "url_syntax" : "http://pubchem.ncbi.nlm.nih.gov/assay/assay.cgi?aid=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://pubchem.ncbi.nlm.nih.gov/",
      "datatype" : "entity",
      "fullname" : null,
      "database" : "NCBI PubChem database of bioassay records",
      "id" : "PubChem_BioAssay",
      "url_example" : "http://pubchem.ncbi.nlm.nih.gov/assay/assay.cgi?aid=177",
      "object" : "entity",
      "name" : "NCBI PubChem database of bioassay records"
   },
   "tgd_ref" : {
      "id" : "TGD_REF",
      "url_example" : "http://db.ciliate.org/cgi-bin/reference/reference.pl?dbid=T000005818",
      "object" : "entity",
      "name" : "Tetrahymena Genome Database",
      "database" : "Tetrahymena Genome Database",
      "abbreviation" : "TGD_REF",
      "example_id" : "TGD_REF:T000005818",
      "url_syntax" : "http://db.ciliate.org/cgi-bin/reference/reference.pl?dbid=[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://www.ciliate.org/",
      "datatype" : "entity"
   },
   "swall" : {
      "database" : "ExPASY Bioinformatics Resource Portal",
      "url_example" : "http://ca.expasy.org/cgi-bin/sprot-search-de?S=1&amp;T=1&amp;SEARCH=12345",
      "object" : "entity",
      "id" : "SWALL",
      "name" : "ExPASY Bioinformatics Resource Portal",
      "url_syntax" : "http://ca.expasy.org/cgi-bin/sprot-search-de?S=1&amp;T=1&amp;SEARCH=[example_id]",
      "example_id" : "SWALL:12345",
      "abbreviation" : "SWALL",
      "datatype" : "entity",
      "generic_url" : "http://ca.expasy.org",
      "fullname" : null,
      "uri_prefix" : null
   },
   "apidb_plasmodb" : {
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://plasmodb.org/",
      "datatype" : "entity",
      "example_id" : "ApiDB_PlasmoDB:PF11_0344",
      "abbreviation" : "ApiDB_PlasmoDB",
      "url_syntax" : "http://www.plasmodb.org/gene/[example_id]",
      "database" : "PlasmoDB Plasmodium Genome Resource",
      "name" : "PlasmoDB Plasmodium Genome Resource",
      "id" : "ApiDB_PlasmoDB",
      "object" : "entity",
      "url_example" : "http://www.plasmodb.org/gene/PF11_0344"
   },
   "pseudocap" : {
      "url_example" : "http://v2.pseudomonas.com/getAnnotation.do?locusID=PA4756",
      "object" : "entity",
      "id" : "PseudoCAP",
      "name" : "Pseudomonas Genome Project",
      "database" : "Pseudomonas Genome Project",
      "url_syntax" : "http://v2.pseudomonas.com/getAnnotation.do?locusID=[example_id]",
      "example_id" : "PseudoCAP:PA4756",
      "abbreviation" : "PseudoCAP",
      "generic_url" : "http://v2.pseudomonas.com/",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null
   },
   "taxon" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.ncbi.nlm.nih.gov/Taxonomy/taxonomyhome.html/",
      "fullname" : null,
      "datatype" : "entity",
      "example_id" : "taxon:7227",
      "abbreviation" : "taxon",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=[example_id]",
      "name" : "NCBI Taxonomy",
      "id" : "taxon",
      "url_example" : "http://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=3702",
      "object" : "entity",
      "database" : "NCBI Taxonomy"
   },
   "cgd_locus" : {
      "database" : "Candida Genome Database",
      "name" : "Candida Genome Database",
      "url_example" : "http://www.candidagenome.org/cgi-bin/locus.pl?locus=HWP1",
      "object" : "entity",
      "id" : "CGD_LOCUS",
      "fullname" : null,
      "generic_url" : "http://www.candidagenome.org/",
      "datatype" : "entity",
      "uri_prefix" : null,
      "url_syntax" : "http://www.candidagenome.org/cgi-bin/locus.pl?locus=[example_id]",
      "abbreviation" : "CGD_LOCUS",
      "example_id" : "CGD_LOCUS:HWP1"
   },
   "ddanat" : {
      "database" : "Dictyostelium discoideum anatomy",
      "object" : "anatomical entity",
      "url_example" : null,
      "id" : "DDANAT",
      "name" : "Dictyostelium discoideum anatomy",
      "url_syntax" : null,
      "example_id" : "DDANAT:0000068",
      "abbreviation" : "DDANAT",
      "generic_url" : "http://dictybase.org/Dicty_Info/dicty_anatomy_ontology.html",
      "fullname" : null,
      "datatype" : "anatomical entity",
      "uri_prefix" : null
   },
   "agricola_ind" : {
      "name" : "AGRICultural OnLine Access",
      "id" : "AGRICOLA_IND",
      "url_example" : null,
      "object" : "entity",
      "database" : "AGRICultural OnLine Access",
      "uri_prefix" : null,
      "generic_url" : "http://agricola.nal.usda.gov/",
      "fullname" : null,
      "datatype" : "entity",
      "abbreviation" : "AGRICOLA_IND",
      "example_id" : "AGRICOLA_IND:IND23252955",
      "url_syntax" : null
   },
   "hpa" : {
      "uri_prefix" : null,
      "datatype" : "entity",
      "generic_url" : "http://www.proteinatlas.org/",
      "fullname" : null,
      "abbreviation" : "HPA",
      "example_id" : "HPA:HPA000237",
      "url_syntax" : "http://www.proteinatlas.org/tissue_profile.php?antibody_id=[example_id]",
      "database" : "Human Protein Atlas tissue profile information",
      "name" : "Human Protein Atlas tissue profile information",
      "id" : "HPA",
      "object" : "entity",
      "url_example" : "http://www.proteinatlas.org/tissue_profile.php?antibody_id=HPA000237"
   },
   "lifedb" : {
      "uri_prefix" : null,
      "generic_url" : "http://www.lifedb.de/",
      "datatype" : "entity",
      "fullname" : "LifeDB is a database for information on protein localization, interaction, functional assays and expression.",
      "example_id" : "LIFEdb:DKFZp564O1716",
      "abbreviation" : "LIFEdb",
      "url_syntax" : "http://www.dkfz.de/LIFEdb/LIFEdb.aspx?ID=[example_id]",
      "database" : "LifeDB",
      "name" : "LifeDB",
      "id" : "LIFEdb",
      "url_example" : "http://www.dkfz.de/LIFEdb/LIFEdb.aspx?ID=DKFZp564O1716",
      "object" : "entity"
   },
   "pharmgkb" : {
      "url_syntax" : "http://www.pharmgkb.org/do/serve?objId=[example_id]",
      "abbreviation" : "PharmGKB",
      "example_id" : "PharmGKB:PA267",
      "generic_url" : "http://www.pharmgkb.org",
      "fullname" : null,
      "datatype" : "entity",
      "uri_prefix" : null,
      "database" : "Pharmacogenetics and Pharmacogenomics Knowledge Base",
      "object" : "entity",
      "url_example" : "http://www.pharmgkb.org/do/serve?objId=PA267",
      "id" : "PharmGKB",
      "name" : "Pharmacogenetics and Pharmacogenomics Knowledge Base"
   },
   "panther" : {
      "abbreviation" : "PANTHER",
      "example_id" : "PANTHER:PTHR11455",
      "url_syntax" : "http://www.pantherdb.org/panther/lookupId.jsp?id=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.pantherdb.org/",
      "fullname" : null,
      "datatype" : "protein family",
      "id" : "PANTHER",
      "url_example" : "http://www.pantherdb.org/panther/lookupId.jsp?id=PTHR10000",
      "object" : "protein family",
      "name" : "Protein ANalysis THrough Evolutionary Relationships Classification System",
      "database" : "Protein ANalysis THrough Evolutionary Relationships Classification System"
   },
   "jcvi_genprop" : {
      "example_id" : "JCVI_GenProp:GenProp0120",
      "abbreviation" : "JCVI_GenProp",
      "url_syntax" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenomePropDefinition.cgi?prop_acc=[example_id]",
      "uri_prefix" : null,
      "fullname" : null,
      "generic_url" : "http://cmr.jcvi.org/",
      "datatype" : "biological_process",
      "database" : "Genome Properties database at the J. Craig Venter Institute",
      "id" : "JCVI_GenProp",
      "object" : "biological_process",
      "url_example" : "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenomePropDefinition.cgi?prop_acc=GenProp0120",
      "name" : "Genome Properties database at the J. Craig Venter Institute"
   },
   "cgd" : {
      "id" : "CGD",
      "url_example" : "http://www.candidagenome.org/cgi-bin/locus.pl?dbid=CAL0005516",
      "object" : "gene",
      "name" : "Candida Genome Database",
      "database" : "Candida Genome Database",
      "abbreviation" : "CGD",
      "example_id" : "CGD:CAL0005516",
      "url_syntax" : "http://www.candidagenome.org/cgi-bin/locus.pl?dbid=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.candidagenome.org/",
      "fullname" : null,
      "datatype" : "gene"
   },
   "rgd" : {
      "url_syntax" : "http://rgd.mcw.edu/rgdweb/search/search.html?term=[example_id]",
      "example_id" : "RGD:2004",
      "abbreviation" : "RGD",
      "fullname" : null,
      "generic_url" : "http://rgd.mcw.edu/",
      "datatype" : "gene",
      "uri_prefix" : null,
      "object" : "gene",
      "url_example" : "http://rgd.mcw.edu/rgdweb/search/search.html?term=2004",
      "id" : "RGD",
      "name" : "Rat Genome Database",
      "database" : "Rat Genome Database"
   },
   "ecogene" : {
      "id" : "ECOGENE",
      "object" : "gene",
      "url_example" : "http://www.ecogene.org/geneInfo.php?eg_id=EG10818",
      "name" : "EcoGene Database of Escherichia coli Sequence and Function",
      "database" : "EcoGene Database of Escherichia coli Sequence and Function",
      "abbreviation" : "ECOGENE",
      "example_id" : "ECOGENE:EG10818",
      "url_syntax" : "http://www.ecogene.org/geneInfo.php?eg_id=[example_id]",
      "uri_prefix" : null,
      "generic_url" : "http://www.ecogene.org/",
      "fullname" : null,
      "datatype" : "gene"
   },
   "grindesc" : {
      "name" : "Germplasm Resources Information Network",
      "object" : "germplasm descriptors",
      "url_example" : "https://npgsweb.ars-grin.gov/gringlobal/descriptordetail.aspx?id=89033",
      "id" : "GRINDesc",
      "database" : "Germplasm Resources Information Network",
      "fullname" : null,
      "generic_url" : "http://www.ars-grin.gov/",
      "datatype" : "germplasm descriptors",
      "uri_prefix" : null,
      "url_syntax" : "https://npgsweb.ars-grin.gov/gringlobal/descriptordetail.aspx?id=[example_id]",
      "abbreviation" : "GRINDesc",
      "example_id" : "GRINdesc:89033"
   },
   "cog_pathway" : {
      "database" : "NCBI COG pathway",
      "url_example" : "http://www.ncbi.nlm.nih.gov/COG/new/release/coglist.cgi?pathw=14",
      "object" : "entity",
      "id" : "COG_Pathway",
      "name" : "NCBI COG pathway",
      "url_syntax" : "http://www.ncbi.nlm.nih.gov/COG/new/release/coglist.cgi?pathw=[example_id]",
      "abbreviation" : "COG_Pathway",
      "example_id" : "COG_Pathway:14",
      "datatype" : "entity",
      "generic_url" : "http://www.ncbi.nlm.nih.gov/COG/",
      "fullname" : null,
      "uri_prefix" : null
   },
   "uberon" : {
      "url_syntax" : "http://purl.obolibrary.org/obo/UBERON_[example_id]",
      "abbreviation" : "UBERON",
      "example_id" : "UBERON:0000069",
      "generic_url" : "http://uberon.org",
      "datatype" : "life cycle stage",
      "fullname" : "A multi-species anatomy ontology",
      "uri_prefix" : null,
      "database" : "Uber-anatomy ontology",
      "object" : "life cycle stage",
      "url_example" : null,
      "id" : "UBERON",
      "name" : "Uber-anatomy ontology"
   }
};

///
/// Exportable body.
///

module.exports = xrefs;
